var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 800",
    style: {
      enableBackground: "new 0 0 1200 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1200,
    height: 800
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013897982616684166770000004004474032930513321_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013897982616684166770000004004474032930513321_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.26
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080927879502762057440000009421022195696507530_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.0146,
    y1: 378.9775,
    x2: 1127.451,
    y2: 378.9775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080927879502762057440000009421022195696507530_)"
    },
    d: "M1093.86,373.34 c-20.36-26.08-48.93-46.02-63.82-75.56c-22.73-45.12-7.98-100.68-23.55-148.75c-13.34-41.2-48.45-72.96-88.4-89.64 c-39.96-16.68-84.4-19.75-127.62-17.1c-89.6,5.49-177.61,35.1-252.32,84.87c-36.79,24.51-70.39,53.78-108.58,76.06 c-38.18,22.28-82.82,37.45-126.4,30.02c-43.54-7.43-79.99-36.01-119.89-54.95c-15.59-7.4-33.12-13.05-50.59-15.35 c-38.21-5.04-72.4,24.27-73.59,62.79c-1.02,32.83,7.2,65.99,24.17,94.15c21.28,35.32,54.46,61.67,80.44,93.69 c25.98,32.02,45.13,75.28,31.07,114.04c-12,33.06-46.51,58.35-45.55,93.51c1.01,36.78,39.98,59.64,74.94,71.14 c102.91,33.84,217.11,32.27,319.04-4.4c58.62-21.09,114.97-53.74,177.22-56.21c65.4-2.59,127.77,28.72,193.13,32.18 c71.52,3.79,145.41-29.52,184.83-89.31C1137.8,514.71,1137.93,429.79,1093.86,373.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143586588628857333400000004110728863853979288_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.9244,
    y1: 1040.2812,
    x2: 364.6956,
    y2: 223.8488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143586588628857333400000004110728863853979288_)"
    },
    d: "M340.83,743.46 c0,0,51.7-89.59,43.3-174.28c-8.4-84.69-50.36-74.59-69.03-24.51c-18.67,50.08-35.45,43.21-24.36-3.88 c11.09-47.08,24.99-77.73,2.01-124.6c-22.98-46.87-25.37-66.79-12.45-108.61c12.91-41.82,29.13-101.08-22.25-122.23 c-51.38-21.14-102.57,43.82-90.59,128.84c11.98,85.02,19.18,94.28,2.68,125.78c-16.5,31.49-9.63,44.43-7.29,64.93 c2.34,20.5-22.88,25.3-22.34-3.57c0.54-28.87,32.61-97.02,10.72-128.81c-21.89-31.79-64.8-32.14-75.79,41.38 c-10.99,73.51,24.22,106.55,22.47,133.14c-1.75,26.59-20.66-13.73-37.13,13.38c-16.47,27.1,5.7,48.39,22.02,63.08 c16.32,14.69,40.92,41.01,17.51,60.13c-23.41,19.12-45.58,0.82-31.24,59.85H340.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M234.54,246.67c-1.69,1.24-3.17,2.79-4.61,4.45c-1.44,1.66-2.76,3.51-4,5.47 c-2.49,3.9-4.59,8.3-6.31,12.97c-3.44,9.36-5.27,19.78-5.88,30.21c-0.11,1.31-0.14,2.61-0.18,3.92 c-0.03,1.31-0.09,2.62-0.07,3.93l0.02,3.92l0.14,3.91l0.08,1.96l0.14,1.94l0.28,3.89c0.28,2.57,0.48,5.17,0.84,7.72 c0.34,2.55,0.68,5.12,1.12,7.63l0.63,3.79l0.66,3.67l2.64,14.64c3.5,19.51,6.86,39.01,9.51,58.61 c2.57,19.59,4.36,39.39,3.96,58.96c-0.09,4.89-0.33,9.75-0.78,14.56c-0.44,4.81-1.05,9.57-1.94,14.21 c-0.88,4.64-1.96,9.19-3.34,13.54c-1.53,4.93-2.73,10.03-3.67,15.1c-1.77,10.17-2.81,20.33-3.61,30.46 c-0.77,10.13-1.37,20.22-1.85,30.29c-1,20.13-1.86,40.2-3.97,59.99c-0.27,2.47-0.55,4.94-0.88,7.39c-0.3,2.47-0.68,4.9-1.05,7.34 c-0.34,2.46-0.83,4.85-1.23,7.28c-0.23,1.2-0.49,2.39-0.74,3.59c-0.25,1.2-0.48,2.4-0.79,3.57l-0.87,3.53 c-0.29,1.18-0.66,2.31-0.98,3.47c-0.63,2.34-1.45,4.54-2.2,6.8c-1.68,4.39-3.65,8.57-6.05,12.31l0.59,0.8 c2.67-3.55,4.93-7.65,6.91-11.99c1.89-4.41,3.53-9.03,4.87-13.8c2.75-9.51,4.57-19.45,6.05-29.41 c2.97-19.95,4.38-40.16,5.98-60.19c0.81-10.01,1.54-20.01,2.53-29.9c0.99-9.88,2.23-19.68,4.07-29.07 c0.97-4.67,2.07-9.16,3.48-13.47c1.61-4.85,2.89-9.88,3.92-14.97c1.05-5.09,1.78-10.26,2.32-15.45 c0.56-5.18,0.88-10.39,1.04-15.57c0.63-20.79-1.24-41.26-3.76-61.34c-2.57-20.09-6.05-39.84-9.93-59.35 c-0.98-4.88-1.97-9.75-2.99-14.6l-0.77-3.64l-0.7-3.54c-0.5-2.36-0.87-4.74-1.29-7.12c-0.43-2.38-0.71-4.78-1.07-7.17l-0.4-3.61 c-0.14-1.2-0.27-2.41-0.36-3.62c-0.49-4.83-0.61-9.68-0.64-14.53c-0.01-4.85,0.28-9.7,0.88-14.47c0.62-4.76,1.46-9.49,2.71-14.04 c0.65-2.26,1.34-4.5,2.16-6.66c0.78-2.19,1.69-4.3,2.68-6.34c1.98-4.05,4.33-7.92,7.12-10.98L234.54,246.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M344.61,550.14c-1.54,15.85-3.73,31.57-6.41,47.08c-1.35,7.75-2.83,15.45-4.47,23.08 c-0.39,1.92-0.85,3.8-1.27,5.7c-0.42,1.9-0.88,3.79-1.34,5.67c-0.87,3.79-1.86,7.52-2.82,11.26c-1.03,3.7-2.04,7.43-3.17,11.07 c-1.05,3.7-2.25,7.3-3.4,10.93c-2.43,7.18-5,14.27-7.85,21.14c-2.84,6.88-5.99,13.52-9.33,19.98 c-3.41,6.39-7.13,12.47-11.06,18.36l0.56,0.84c4.56-5.07,8.75-10.78,12.61-16.9c3.8-6.19,7.27-12.77,10.44-19.62 c3.06-6.93,5.95-14.01,8.44-21.36c1.21-3.69,2.47-7.36,3.56-11.12c1.14-3.74,2.14-7.54,3.17-11.33c0.96-3.82,1.94-7.64,2.8-11.5 c0.46-1.92,0.87-3.86,1.27-5.81c0.39-1.95,0.83-3.88,1.19-5.83c1.56-7.79,2.84-15.67,3.95-23.59c2.18-15.85,3.7-31.86,3.96-47.99 L344.61,550.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133528269313444333840000013426848096940539265_",
    gradientUnits: "userSpaceOnUse",
    x1: 783.8503,
    y1: 1021.5707,
    x2: 1120.3892,
    y2: 270.0772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133528269313444333840000013426848096940539265_)"
    },
    d: "M1109.1,743.46 c0,0,51.7-81.36,43.3-158.28c-8.4-76.91-50.36-67.74-69.03-22.26c-18.67,45.48-35.45,39.24-24.36-3.52 c11.09-42.76,24.99-70.59,2.01-113.16c-22.98-42.57-25.37-60.65-12.45-98.63c12.91-37.98,29.13-91.8-22.25-111 c-51.38-19.2-102.57,39.79-90.59,117.01c11.98,77.21,19.18,85.62,2.68,114.23c-16.5,28.6-9.63,40.35-7.29,58.96 c2.34,18.62-22.88,22.97-22.34-3.25c0.54-26.22,32.61-88.11,10.72-116.98c-21.89-28.87-64.8-29.18-75.79,37.58 c-10.99,66.76,24.22,96.76,22.47,120.91c-1.75,24.15-20.66-12.47-37.13,12.15c-16.47,24.61,5.71,43.95,22.02,57.29 c16.32,13.34,40.92,37.24,17.51,54.61c-23.41,17.36-45.58,0.75-31.24,54.35H1109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M1002.81,292.3c-1.69,1.12-3.17,2.53-4.61,4.04c-1.44,1.51-2.76,3.19-4,4.97 c-2.49,3.54-4.59,7.53-6.31,11.78c-3.44,8.5-5.27,17.96-5.88,27.43c-0.11,1.19-0.14,2.37-0.18,3.56 c-0.03,1.19-0.09,2.38-0.07,3.56l0.02,3.56l0.14,3.55l0.08,1.78l0.14,1.77l0.28,3.54c0.28,2.33,0.48,4.7,0.84,7.01 c0.34,2.32,0.68,4.65,1.12,6.93l0.63,3.45l0.66,3.33l2.64,13.29c3.5,17.72,6.86,35.43,9.51,53.23 c2.58,17.79,4.36,35.78,3.96,53.55c-0.09,4.44-0.33,8.86-0.78,13.22c-0.44,4.36-1.05,8.69-1.94,12.9 c-0.88,4.21-1.96,8.34-3.34,12.29c-1.53,4.47-2.73,9.11-3.67,13.71c-1.77,9.23-2.81,18.46-3.61,27.66 c-0.77,9.2-1.37,18.36-1.85,27.51c-1,18.28-1.86,36.51-3.97,54.48c-0.27,2.25-0.55,4.49-0.88,6.71c-0.3,2.24-0.68,4.45-1.05,6.67 c-0.34,2.23-0.83,4.4-1.23,6.61c-0.23,1.09-0.49,2.17-0.74,3.26c-0.25,1.09-0.48,2.18-0.79,3.24l-0.87,3.21 c-0.29,1.07-0.66,2.1-0.98,3.15c-0.63,2.12-1.45,4.12-2.2,6.18c-1.68,3.98-3.65,7.79-6.05,11.18l0.59,0.73 c2.67-3.23,4.93-6.94,6.91-10.89c1.89-4,3.53-8.2,4.87-12.53c2.75-8.64,4.57-17.66,6.05-26.71c2.97-18.12,4.38-36.48,5.98-54.66 c0.81-9.09,1.54-18.17,2.53-27.16c0.99-8.98,2.23-17.88,4.07-26.4c0.97-4.24,2.07-8.32,3.48-12.23c1.61-4.41,2.89-8.97,3.92-13.6 c1.05-4.62,1.78-9.32,2.32-14.03c0.56-4.71,0.88-9.43,1.04-14.14c0.63-18.88-1.24-37.47-3.76-55.71 c-2.57-18.25-6.05-36.18-9.93-53.9c-0.98-4.43-1.97-8.85-2.99-13.26l-0.77-3.3l-0.7-3.22c-0.5-2.14-0.87-4.31-1.29-6.47 c-0.43-2.16-0.71-4.34-1.07-6.52l-0.4-3.28c-0.14-1.09-0.27-2.19-0.36-3.29c-0.49-4.39-0.61-8.79-0.64-13.2 c-0.01-4.41,0.28-8.81,0.88-13.14c0.62-4.32,1.46-8.62,2.71-12.75c0.65-2.05,1.34-4.09,2.16-6.05c0.78-1.99,1.69-3.9,2.68-5.76 c1.98-3.68,4.33-7.19,7.12-9.97L1002.81,292.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "#FFFFFF"
    },
    d: "M1112.88,567.9c-1.54,14.4-3.73,28.67-6.41,42.76c-1.35,7.04-2.83,14.03-4.47,20.96 c-0.39,1.74-0.85,3.45-1.27,5.18c-0.42,1.73-0.88,3.44-1.34,5.15c-0.87,3.44-1.86,6.83-2.82,10.23 c-1.03,3.36-2.04,6.74-3.17,10.06c-1.05,3.36-2.25,6.63-3.4,9.92c-2.43,6.52-5,12.96-7.85,19.2c-2.84,6.25-5.99,12.27-9.33,18.14 c-3.41,5.8-7.13,11.32-11.06,16.68l0.56,0.76c4.56-4.6,8.75-9.79,12.61-15.35c3.8-5.63,7.27-11.6,10.44-17.81 c3.06-6.29,5.95-12.73,8.44-19.4c1.21-3.35,2.47-6.68,3.56-10.1c1.14-3.39,2.14-6.85,3.17-10.29c0.96-3.47,1.94-6.94,2.8-10.45 c0.46-1.75,0.87-3.51,1.27-5.27c0.39-1.77,0.83-3.52,1.19-5.3c1.56-7.07,2.84-14.23,3.95-21.42c2.18-14.39,3.7-28.94,3.96-43.58 L1112.88,567.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037665055647814438680000010239648051950483132_",
    gradientUnits: "userSpaceOnUse",
    x1: 994.6056,
    y1: 710.5396,
    x2: 746.5367,
    y2: 364.1375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037665055647814438680000010239648051950483132_)"
    },
    d: "M977.61,746.27H826.36V432.29h162.81 v302.42C989.17,741.1,983.99,746.27,977.61,746.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146472133383608482650000000520807749780633782_",
    gradientUnits: "userSpaceOnUse",
    x1: 818.6113,
    y1: 388.6779,
    x2: 1019.3398,
    y2: 388.6779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146472133383608482650000000520807749780633782_)"
    },
    d: "M1010.98,459.42H818.61V325.69 l151.18-7.75l48.77,129.62C1021.12,453.09,1017.08,459.42,1010.98,459.42z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M953.65,660.99h-90.79c-0.62,0-1.12-0.5-1.12-1.12V518.69c0-0.62,0.5-1.12,1.12-1.12h90.79 c0.62,0,1.12,0.5,1.12,1.12v141.18C954.77,660.49,954.27,660.99,953.65,660.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122719659841518068220000016635975123051158163_",
    gradientUnits: "userSpaceOnUse",
    x1: 887.4979,
    y1: 379.9522,
    x2: 884.5604,
    y2: 1049.7135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122719659841518068220000016635975123051158163_)"
    },
    d: "M904.02,653.24h-34.87 c-0.34,0-0.62-0.28-0.62-0.62V525.94c0-0.34,0.28-0.62,0.62-0.62h34.87c0.34,0,0.62,0.28,0.62,0.62v126.67 C904.64,652.96,904.36,653.24,904.02,653.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099628861534335020470000010058658267917477772_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.8419,
    y1: 380.1418,
    x2: 927.9042,
    y2: 1049.9031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099628861534335020470000010058658267917477772_)"
    },
    d: "M947.36,653.24h-34.87 c-0.34,0-0.62-0.28-0.62-0.62V525.94c0-0.34,0.28-0.62,0.62-0.62h34.87c0.34,0,0.62,0.28,0.62,0.62v126.67 C947.98,652.96,947.71,653.24,947.36,653.24z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100353395819000281440000001485389906190843070_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.1748,
    y1: 710.5396,
    x2: -390.2437,
    y2: 364.1375,
    gradientTransform: "matrix(-1 0 0 1 80.3436 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100353395819000281440000001485389906190843070_)"
    },
    d: "M239.52,746.27h151.24V432.29H227.95 v302.42C227.95,741.1,233.13,746.27,239.52,746.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074411169752125022450000013700702808190088083_",
    gradientUnits: "userSpaceOnUse",
    x1: -318.1691,
    y1: 388.6779,
    x2: -117.4406,
    y2: 388.6779,
    gradientTransform: "matrix(-1 0 0 1 80.3436 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074411169752125022450000013700702808190088083_)"
    },
    d: "M206.15,459.42h192.37V325.69 l-151.18-7.75l-48.77,129.62C196,453.09,200.04,459.42,206.15,459.42z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.48,660.99h90.79c0.62,0,1.12-0.5,1.12-1.12V518.69c0-0.62-0.5-1.12-1.12-1.12h-90.79 c-0.62,0-1.12,0.5-1.12,1.12v141.18C262.36,660.49,262.86,660.99,263.48,660.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173852056888739869200000009796760324763161783_",
    gradientUnits: "userSpaceOnUse",
    x1: -249.2825,
    y1: 379.9522,
    x2: -252.2201,
    y2: 1049.7135,
    gradientTransform: "matrix(-1 0 0 1 80.3436 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173852056888739869200000009796760324763161783_)"
    },
    d: "M313.11,653.24h34.87 c0.34,0,0.62-0.28,0.62-0.62V525.94c0-0.34-0.28-0.62-0.62-0.62h-34.87c-0.34,0-0.62,0.28-0.62,0.62v126.67 C312.48,652.96,312.76,653.24,313.11,653.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132075035322265092710000012729663600494375614_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.9385,
    y1: 380.1418,
    x2: -208.8761,
    y2: 1049.9031,
    gradientTransform: "matrix(-1 0 0 1 80.3436 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132075035322265092710000012729663600494375614_)"
    },
    d: "M269.76,653.24h34.87 c0.34,0,0.62-0.28,0.62-0.62V525.94c0-0.34-0.28-0.62-0.62-0.62h-34.87c-0.34,0-0.62,0.28-0.62,0.62v126.67 C269.14,652.96,269.42,653.24,269.76,653.24z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019666803619442131590000009522448942353706416_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.1985,
    y1: 386.0475,
    x2: 709.4862,
    y2: 386.0475,
    gradientTransform: "matrix(1.1995 -0.013 0.0108 0.9999 -7.7659 142.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019666803619442131590000009522448942353706416_)"
    },
    d: "M785.01,766.75l-361.89,3.9 c-28.7,0.31-52.18-18.84-52.44-42.76l-4.31-399.29c-0.25-23.5,22.02-42.96,50.19-43.86l374.92-11.92 c29.75-0.95,54.27,19.09,53.74,43.9l-8.72,407.31C836,747.51,813.17,766.45,785.01,766.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008128202269776347450000011070924812197588883_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.3723,
    y1: 806.2288,
    x2: 619.0671,
    y2: 239.9721,
    gradientTransform: "matrix(1.1996 -2.200000e-03 -2.200000e-03 1 35.3268 -0.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008128202269776347450000011070924812197588883_)"
    },
    d: "M423.02,761.48 c-22.59,0.24-41.13-14.88-41.33-33.71l-4.31-399.29c-0.2-18.67,17.18-33.86,39.56-34.57l374.92-11.92 c0.35-0.01,0.71-0.02,1.06-0.02c11.13-0.12,21.59,3.44,29.44,10.01c7.85,6.57,12.06,15.31,11.86,24.61l-8.72,407.31 c-0.4,18.64-18.23,33.43-40.59,33.67L423.02,761.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "#FFFFFF"
    },
    d: "M422.73,733.96c-4.38,0.05-7.98-2.89-8.02-6.54l-4.31-399.29 c-0.04-3.74,3.19-6.56,7.68-6.71l375.15-11.93c2.21-0.02,4.12,0.63,5.69,1.94c1.57,1.31,2.34,2.92,2.3,4.77l-8.72,407.31 c-0.08,3.74-3.39,6.48-7.87,6.53L422.73,733.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092436683856964786010000011959592669282209926_",
    gradientUnits: "userSpaceOnUse",
    x1: -2098.8552,
    y1: 102.7851,
    x2: -2137.6755,
    y2: 150.3785,
    gradientTransform: "matrix(0.5452 -0.8383 0.8383 0.5452 1587.0105 -1120.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6645,
    style: {
      stopColor: "#E57A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000092436683856964786010000011959592669282209926_)"
    },
    cx: 533.43,
    cy: 709.6,
    r: 16.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101801767717490560860000017721616528895609267_",
    gradientUnits: "userSpaceOnUse",
    x1: -2066.7451,
    y1: 151.4131,
    x2: -2105.5657,
    y2: 199.0065,
    gradientTransform: "matrix(0.5452 -0.8383 0.8383 0.5452 1587.0105 -1120.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6645,
    style: {
      stopColor: "#E57A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000101801767717490560860000017721616528895609267_)"
    },
    cx: 591.7,
    cy: 709.2,
    r: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "#FFFFFF"
    },
    d: "M658.72,695.33c7.43,4.83,9.54,14.78,4.71,22.21c-4.83,7.43-14.78,9.54-22.21,4.71 c-7.43-4.83-9.54-14.78-4.71-22.21C641.35,692.6,651.29,690.5,658.72,695.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "#FFFFFF"
    },
    d: "M717,694.93c7.43,4.83,9.54,14.78,4.71,22.21c-4.83,7.43-14.78,9.54-22.21,4.71 c-7.43-4.83-9.54-14.78-4.71-22.21C699.62,692.2,709.56,690.09,717,694.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147939179833709377020000010706271014361841026_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.7082,
    y1: -37.6078,
    x2: 604.7834,
    y2: 495.8269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147939179833709377020000010706271014361841026_)"
    },
    d: "M825.93,164.13H384.02l-48.96,168.25 c-1.14,3.93-0.49,8.16,1.8,11.58l5.04,7.54c2.68,4.02,7.27,6.45,12.2,6.45h500.33c5.69,0,10.86-3.23,13.23-8.26l4.84-10.28 c1.43-3.04,1.71-6.48,0.79-9.7L825.93,164.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163776617337808972700000009263206195329511045_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.8425,
    y1: -70.9221,
    x2: 604.9178,
    y2: 161.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163776617337808972700000009263206195329511045_)"
    },
    d: "M826.93,164.13h-444.1v-7.63 c0-2.88,2.38-5.23,5.34-5.28l433.26-6.4c3.03-0.04,5.5,2.33,5.5,5.28V164.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M507.07,338.12h-138.3c-3.41,0-6.54-1.57-8.59-4.3c-2.04-2.73-2.66-6.18-1.7-9.45l39.51-134.08 c0.08-0.28,0.37-0.44,0.65-0.35c0.28,0.08,0.44,0.37,0.36,0.65l-39.51,134.08c-0.87,2.95-0.31,6.06,1.53,8.53 c1.84,2.47,4.67,3.88,7.75,3.88h138.3c0.29,0,0.52,0.23,0.52,0.52C507.59,337.89,507.36,338.12,507.07,338.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M841.05,298.89c-0.23,0-0.43-0.15-0.5-0.37l-30.73-101.54c-2.1-6.94-8.38-11.64-15.62-11.7 c-80.44-0.63-129.69-0.61-131.75,0.07c-0.27,0.09-0.57-0.05-0.67-0.31c-0.1-0.26,0.02-0.55,0.28-0.66 c2.47-1.01,83.85-0.53,132.15-0.14c7.71,0.06,14.38,5.06,16.62,12.44l30.73,101.54c0.08,0.28-0.07,0.57-0.35,0.65 C841.15,298.88,841.1,298.89,841.05,298.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070831154779406305680000017636806378949528995_",
    gradientUnits: "userSpaceOnUse",
    x1: 581.8677,
    y1: 28.7061,
    x2: 658.4244,
    y2: 359.2908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070831154779406305680000017636806378949528995_)"
    },
    d: "M601.9,161.04 c-9.85,8.14-11.25,22.77-3.11,32.62c8.13,9.85,22.77,11.25,32.62,3.12c9.85-8.14,11.25-22.77,3.11-32.62 C626.39,154.31,611.75,152.91,601.9,161.04z M625.55,189.69c-5.94,4.91-14.77,4.06-19.68-1.88c-4.91-5.94-4.06-14.77,1.88-19.68 c5.94-4.91,14.77-4.06,19.68,1.88C632.34,175.96,631.49,184.78,625.55,189.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102544481253480259710000008327557289048707467_",
    gradientUnits: "userSpaceOnUse",
    x1: 592.6912,
    y1: 26.1999,
    x2: 669.2477,
    y2: 356.7842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102544481253480259710000008327557289048707467_)"
    },
    d: "M665.41,138.65 c-22.2-26.88-62.14-30.7-89.02-8.5c-2.04,1.68-3.93,3.47-5.7,5.34c-1.32,1.4-1.22,3.62,0.24,4.88l5.37,4.63 c1.36,1.17,3.39,1.07,4.62-0.23c1.32-1.4,2.73-2.74,4.25-3.99c21.02-17.36,52.24-14.38,69.6,6.64c1.08,1.3,2.07,2.65,2.98,4.03 c1.23,1.85,3.85,2.1,5.33,0.44l4.86-5.41c1.06-1.18,1.14-2.93,0.22-4.23C667.3,141.03,666.39,139.83,665.41,138.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038397507763736092350000012635145211123873179_",
    gradientUnits: "userSpaceOnUse",
    x1: 596.7039,
    y1: 25.2707,
    x2: 673.2606,
    y2: 355.8553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038397507763736092350000012635145211123873179_)"
    },
    d: "M553.7,102.67 c-3.65,3.01-7,6.24-10.1,9.64c-1.26,1.38-1.09,3.54,0.33,4.77l5.36,4.62c1.36,1.18,3.43,1.09,4.64-0.24 c2.62-2.87,5.47-5.6,8.55-8.15c36.18-29.87,89.9-24.74,119.77,11.44l0.03,0.03c1.31,1.58,3.7,1.67,5.07,0.14l4.77-5.31 c0.04-1.68,0.06-2.77,0.1-4.46C657.38,73.84,595.47,68.18,553.7,102.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039843600979895978910000005516174792050326961_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.9457,
    y1: 24.2883,
    x2: 677.5024,
    y2: 354.8728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039843600979895978910000005516174792050326961_)"
    },
    d: "M716.12,88.42 c-47.93-52.74-129.59-59.08-185.12-13.24c-5.22,4.31-10,8.94-14.38,13.83c-1.25,1.4-1.08,3.56,0.34,4.78l5.35,4.62 c1.39,1.2,3.48,1.04,4.71-0.33c3.9-4.33,8.15-8.44,12.77-12.26c49.99-41.28,123.6-35.43,166.56,12.33 c1.35,1.5,3.68,1.54,5.03,0.04l4.73-5.26C717.26,91.65,717.28,89.69,716.12,88.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.73,
      fill: "#FFFFFF"
    },
    d: "M604.16,631.1c-42.88,0-77.77-34.89-77.77-77.77c0-42.88,34.89-77.77,77.77-77.77 c42.88,0,77.77,34.89,77.77,77.77C681.93,596.21,647.04,631.1,604.16,631.1z M604.16,499.95c-29.43,0-53.38,23.95-53.38,53.38 c0,29.43,23.95,53.38,53.38,53.38c29.43,0,53.38-23.95,53.38-53.38C657.54,523.9,633.59,499.95,604.16,499.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047051394215180815870000000276120596480271760_",
    gradientUnits: "userSpaceOnUse",
    x1: 679.2385,
    y1: 533.4406,
    x2: 665.951,
    y2: 568.1924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#DD397A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047051394215180815870000000276120596480271760_)"
    },
    d: "M681.71,547.51l-24.32,1.82 c0.1,1.32,0.15,2.65,0.15,3.99c0,6.36-1.12,12.46-3.17,18.12l22.94,8.28c2.99-8.25,4.62-17.14,4.62-26.4 C681.93,551.37,681.85,549.43,681.71,547.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008140520826533878500000002883023475917815735_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.8029,
    y1: 496.3357,
    x2: 499.6272,
    y2: 666.5008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008140520826533878500000002883023475917815735_)"
    },
    d: "M604.16,606.71 c-29.43,0-53.38-23.95-53.38-53.38c0-29.43,23.95-53.38,53.38-53.38c4.48,0,8.84,0.56,13,1.61l5.94-23.65 c-6.07-1.52-12.41-2.34-18.95-2.34c-42.88,0-77.77,34.89-77.77,77.77c0,42.88,34.89,77.77,77.77,77.77 c33.61,0,62.31-21.44,73.15-51.36l-22.94-8.28C646.93,591.99,627.23,606.71,604.16,606.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096764497853058078570000000905162472030250135_",
    gradientUnits: "userSpaceOnUse",
    x1: 705.9832,
    y1: 475.9029,
    x2: 635.4573,
    y2: 589.3575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096764497853058078570000000905162472030250135_)"
    },
    d: "M657.39,549.34l24.32-1.82 c-0.75-10.06-3.42-19.59-7.65-28.23l-21.92,10.68C655.04,535.89,656.88,542.43,657.39,549.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181077547602221487140000008131409881294256771_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.4193,
    y1: 273.1868,
    x2: 562.1579,
    y2: 412.9591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000181077547602221487140000008131409881294256771_)"
    },
    cx: 657.14,
    cy: 291.45,
    r: 38.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M671.69,314.26h-28.67c-2.05,0-3.75-1.61-3.86-3.65l-2.08-37.88c-0.06-1.07,0.32-2.09,1.05-2.87 c0.74-0.78,1.74-1.21,2.81-1.21h30.75c2.13,0,3.87,1.74,3.87,3.87v37.88C675.56,312.53,673.82,314.26,671.69,314.26z  M640.94,270.44c-0.58,0-1.11,0.23-1.51,0.65c-0.4,0.42-0.6,0.97-0.57,1.54l2.08,37.88c0.06,1.1,0.97,1.96,2.07,1.96h28.67 c1.15,0,2.08-0.93,2.08-2.08v-37.88c0-1.15-0.93-2.08-2.08-2.08H640.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M657.6,307.27c-6.94,0-12.59-5.65-12.59-12.59c0-6.94,5.65-12.59,12.59-12.59 c6.94,0,12.59,5.65,12.59,12.59C670.19,301.62,664.54,307.27,657.6,307.27z M657.6,283.87c-5.96,0-10.8,4.85-10.8,10.8 c0,5.96,4.85,10.8,10.8,10.8c5.96,0,10.8-4.85,10.8-10.8C668.4,288.72,663.56,283.87,657.6,283.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M657.71,304.47c-5.16,0-9.36-4.2-9.36-9.36c0-5.16,4.2-9.36,9.36-9.36c5.16,0,9.36,4.2,9.36,9.36 C667.07,300.27,662.88,304.47,657.71,304.47z M657.71,287.54c-4.17,0-7.57,3.4-7.57,7.57c0,4.17,3.4,7.57,7.57,7.57 c4.17,0,7.57-3.4,7.57-7.57C665.28,290.93,661.89,287.54,657.71,287.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M652.99,278.49h-12.02v-6.61h12.02V278.49z M642.77,276.7h8.43v-3.03h-8.43V276.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M669.74,275.63h-11.38v-3.31h11.38V275.63z M659.26,274.74h9.59v-1.52h-9.59V274.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M664.06,300.36c-0.26,0-0.52-0.11-0.7-0.33c-4.32-5.36,0.07-9.21,0.12-9.25 c0.38-0.32,0.94-0.28,1.26,0.1c0.32,0.37,0.28,0.94-0.1,1.26c-0.33,0.28-3.04,2.85,0.11,6.77c0.31,0.38,0.25,0.95-0.14,1.26 C664.45,300.29,664.25,300.36,664.06,300.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M659.79,279.35c-1.03,0-1.87-0.84-1.87-1.87c0-1.03,0.84-1.87,1.87-1.87 c1.03,0,1.87,0.84,1.87,1.87C661.65,278.51,660.81,279.35,659.79,279.35z M659.79,277.41c-0.04,0-0.08,0.03-0.08,0.08 c0,0.08,0.15,0.08,0.15,0C659.86,277.44,659.83,277.41,659.79,277.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M664.19,279.35c-1.03,0-1.87-0.84-1.87-1.87c0-1.03,0.84-1.87,1.87-1.87 c1.03,0,1.87,0.84,1.87,1.87C666.05,278.51,665.21,279.35,664.19,279.35z M664.19,277.41c-0.04,0-0.08,0.03-0.08,0.08 c0,0.08,0.15,0.08,0.15,0C664.26,277.44,664.23,277.41,664.19,277.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M668.04,279.35c-1.03,0-1.87-0.84-1.87-1.87c0-1.03,0.84-1.87,1.87-1.87 c1.03,0,1.87,0.84,1.87,1.87C669.91,278.51,669.07,279.35,668.04,279.35z M668.04,277.41c-0.04,0-0.08,0.03-0.08,0.08 c0,0.08,0.15,0.08,0.15,0C668.12,277.44,668.08,277.41,668.04,277.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080202013265665887540000009031842757838513332_",
    gradientUnits: "userSpaceOnUse",
    x1: 768.1848,
    y1: 273.0621,
    x2: 658.1771,
    y2: 413.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080202013265665887540000009031842757838513332_)"
    },
    cx: 753.81,
    cy: 291.45,
    r: 38.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M751.46,320.13c-4.46,0-8.1-3.63-8.1-8.09c0-3.05,1.7-5.82,4.39-7.2v-33.41 c0-2.04,1.66-3.7,3.7-3.7c2.04,0,3.7,1.66,3.7,3.7v33.41c2.69,1.38,4.39,4.15,4.39,7.2 C759.56,316.49,755.93,320.13,751.46,320.13z M751.46,269.51c-1.06,0-1.91,0.86-1.91,1.91v34.57l-0.55,0.23 c-2.34,0.99-3.85,3.27-3.85,5.81c0,3.48,2.83,6.3,6.31,6.3c3.48,0,6.31-2.83,6.31-6.3c0-2.54-1.51-4.82-3.85-5.81l-0.55-0.23 v-34.57C753.38,270.37,752.52,269.51,751.46,269.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M767.1,271.61h-8.44c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h8.44 c0.49,0,0.9,0.4,0.9,0.89C767.99,271.21,767.59,271.61,767.1,271.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,274.58h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h4.22 c0.49,0,0.9,0.4,0.9,0.89C763.78,274.18,763.38,274.58,762.88,274.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,277.54h-4.22c-0.49,0-0.9-0.4-0.9-0.89s0.4-0.9,0.9-0.9h4.22c0.49,0,0.9,0.4,0.9,0.9 S763.38,277.54,762.88,277.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,280.5h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h4.22 c0.49,0,0.9,0.4,0.9,0.89C763.78,280.1,763.38,280.5,762.88,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M767.1,271.61h-8.44c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h8.44 c0.49,0,0.9,0.4,0.9,0.89C767.99,271.21,767.59,271.61,767.1,271.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,274.58h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h4.22 c0.49,0,0.9,0.4,0.9,0.89C763.78,274.18,763.38,274.58,762.88,274.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,277.54h-4.22c-0.49,0-0.9-0.4-0.9-0.89s0.4-0.9,0.9-0.9h4.22c0.49,0,0.9,0.4,0.9,0.9 S763.38,277.54,762.88,277.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,280.5h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h4.22 c0.49,0,0.9,0.4,0.9,0.89C763.78,280.1,763.38,280.5,762.88,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M767.1,283.46h-8.44c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.89,0.9-0.89h8.44 c0.49,0,0.9,0.4,0.9,0.89C767.99,283.06,767.59,283.46,767.1,283.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,286.42h-4.22c-0.49,0-0.9-0.4-0.9-0.89c0-0.49,0.4-0.9,0.9-0.9h4.22 c0.49,0,0.9,0.4,0.9,0.9C763.78,286.02,763.38,286.42,762.88,286.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,289.39h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.9,0.9-0.9h4.22 c0.49,0,0.9,0.4,0.9,0.9C763.78,288.99,763.38,289.39,762.88,289.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,292.35h-4.22c-0.49,0-0.9-0.4-0.9-0.89s0.4-0.89,0.9-0.89h4.22c0.49,0,0.9,0.4,0.9,0.89 S763.38,292.35,762.88,292.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M767.1,295.31h-8.44c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.9,0.9-0.9h8.44 c0.49,0,0.9,0.4,0.9,0.9C767.99,294.91,767.59,295.31,767.1,295.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,298.27h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.9,0.9-0.9h4.22 c0.49,0,0.9,0.4,0.9,0.9C763.78,297.87,763.38,298.27,762.88,298.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,301.24h-4.22c-0.49,0-0.9-0.4-0.9-0.89s0.4-0.89,0.9-0.89h4.22c0.49,0,0.9,0.4,0.9,0.89 S763.38,301.24,762.88,301.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M762.88,304.2h-4.22c-0.49,0-0.9-0.4-0.9-0.9c0-0.49,0.4-0.9,0.9-0.9h4.22 c0.49,0,0.9,0.4,0.9,0.9C763.78,303.8,763.38,304.2,762.88,304.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177475662962341951440000013325542959272621749_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.8489,
    y1: 273.0621,
    x2: 464.8413,
    y2: 413.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000177475662962341951440000013325542959272621749_)"
    },
    cx: 560.47,
    cy: 291.45,
    r: 38.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M561.22,312.53h-0.56c-3.58,0-6.48-2.91-6.48-6.48v-0.99c0-2.61-1.25-4.97-3.33-6.31 c-5.72-3.7-8.96-10.22-8.47-17.02c0.66-9.17,8.08-16.56,17.25-17.19c5.23-0.36,10.21,1.4,14.03,4.96 c3.76,3.51,5.92,8.47,5.92,13.62c0,6.33-3.18,12.17-8.5,15.63c-2.1,1.36-3.36,3.68-3.36,6.2v1.12 C567.71,309.62,564.8,312.53,561.22,312.53z M560.95,266.27c-0.4,0-0.81,0.01-1.21,0.04c-8.29,0.57-14.99,7.25-15.58,15.54 c-0.44,6.15,2.49,12.05,7.66,15.39c2.6,1.68,4.15,4.6,4.15,7.82v0.99c0,2.59,2.11,4.69,4.7,4.69h0.56 c2.59,0,4.69-2.11,4.69-4.69v-1.12c0-3.13,1.56-6.01,4.17-7.7c4.81-3.12,7.68-8.4,7.68-14.13c0-4.65-1.95-9.14-5.35-12.31 C569.27,267.85,565.23,266.27,560.95,266.27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M566.74,317.51h-11.61c-0.49,0-0.89-0.4-0.89-0.9v-2.27c0-0.49,0.4-0.9,0.89-0.9h11.61 c0.49,0,0.9,0.4,0.9,0.9v2.27C567.64,317.11,567.24,317.51,566.74,317.51z M556.03,315.72h9.82v-0.48h-9.82V315.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M561.23,324.32h-1.17c-2.67,0-4.85-2.18-4.85-4.85v-0.59c0-0.49,0.4-0.9,0.9-0.9h9.67 c0.49,0,0.9,0.4,0.9,0.9C566.67,321.88,564.23,324.32,561.23,324.32z M557.02,319.78c0.16,1.54,1.46,2.75,3.05,2.75h1.17 c1.7,0,3.14-1.17,3.54-2.75H557.02z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M560.47,306.71c-0.41,0-0.77-0.28-0.87-0.69l-5.34-22.66c-0.11-0.48,0.18-0.96,0.67-1.08 c0.48-0.12,0.96,0.18,1.08,0.67l5.34,22.66c0.11,0.48-0.18,0.96-0.67,1.08C560.61,306.71,560.54,306.71,560.47,306.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M563.19,306.71c-0.05,0-0.1,0-0.15-0.01c-0.49-0.08-0.82-0.54-0.74-1.03l3.55-21.79 c0.08-0.49,0.54-0.82,1.03-0.74c0.49,0.08,0.82,0.54,0.74,1.03l-3.55,21.79C564,306.4,563.62,306.71,563.19,306.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M557.8,285.92c-0.11,0-0.22-0.02-0.32-0.06c-0.46-0.18-0.69-0.69-0.51-1.16l2.13-5.55 c0.13-0.33,0.44-0.55,0.79-0.57c0.34-0.03,0.68,0.17,0.84,0.49l2.18,4.31l1.35-1.69c0.31-0.38,0.87-0.45,1.26-0.14 c0.39,0.31,0.45,0.87,0.14,1.26l-2.22,2.77c-0.19,0.24-0.49,0.36-0.79,0.33c-0.3-0.03-0.57-0.21-0.71-0.49l-1.9-3.75l-1.41,3.66 C558.5,285.7,558.16,285.92,557.8,285.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165944648933692123710000002336134790752854935_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.181,
    y1: 273.0621,
    x2: 368.1734,
    y2: 413.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000165944648933692123710000002336134790752854935_)"
    },
    cx: 463.8,
    cy: 291.45,
    r: 38.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M464.05,318.36c-11.09,0-20.11-9.02-20.11-20.11v-7.26c0-0.49,0.4-0.9,0.89-0.9h38.43 c0.49,0,0.9,0.4,0.9,0.9v7.26C484.16,309.34,475.14,318.36,464.05,318.36z M445.74,291.89v6.37c0,10.1,8.22,18.32,18.32,18.32 c10.1,0,18.32-8.22,18.32-18.32v-6.37H445.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M478.54,289.69c-0.49,0-0.89-0.4-0.89-0.9v-10.57c0-6.56-5.33-11.89-11.89-11.89h-3.99 c-6.56,0-11.89,5.33-11.89,11.89v10.57c0,0.49-0.4,0.9-0.9,0.9c-0.49,0-0.89-0.4-0.89-0.9v-10.57c0-7.54,6.14-13.68,13.68-13.68 h3.99c7.54,0,13.68,6.14,13.68,13.68v10.57C479.43,289.29,479.03,289.69,478.54,289.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M475.23,289.69c-0.49,0-0.9-0.4-0.9-0.9v-9.06c0-5.55-4.05-10.07-9.03-10.07h-3.1 c-4.98,0-9.03,4.52-9.03,10.07v9.06c0,0.49-0.4,0.9-0.9,0.9c-0.49,0-0.89-0.4-0.89-0.9v-9.06c0-6.54,4.85-11.86,10.82-11.86h3.1 c5.97,0,10.82,5.32,10.82,11.86v9.06C476.13,289.29,475.73,289.69,475.23,289.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M464.22,312.58c-1.49,0-2.71-1.22-2.71-2.71v-5.29c-1.9-1.09-2.95-3.21-2.64-5.43 c0.33-2.4,2.31-4.33,4.72-4.61c1.54-0.18,3.08,0.31,4.23,1.33c1.15,1.02,1.81,2.49,1.81,4.03c0,1.94-1.04,3.71-2.69,4.67v5.29 C466.93,311.36,465.71,312.58,464.22,312.58z M464.22,296.29c-0.14,0-0.29,0.01-0.43,0.02c-1.61,0.18-2.93,1.48-3.15,3.07 c-0.22,1.63,0.63,3.16,2.12,3.82c0.32,0.14,0.53,0.46,0.53,0.82v5.84c0,0.51,0.41,0.92,0.92,0.92c0.51,0,0.92-0.41,0.92-0.92 v-5.84c0-0.35,0.21-0.68,0.53-0.82c1.31-0.58,2.16-1.88,2.16-3.31c0-1.03-0.44-2.01-1.21-2.7 C465.95,296.61,465.11,296.29,464.22,296.29z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M542.16,458.97c-1.93,0-3.5-1.57-3.5-3.5v-24.59c0-1.94-1.58-3.52-3.52-3.52h-65.85 c-5.8,0-10.52-4.72-10.52-10.52v-74.75c0-1.93,1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5v74.75c0,1.94,1.58,3.52,3.52,3.52h65.85 c5.8,0,10.52,4.72,10.52,10.52v24.59C545.66,457.4,544.09,458.97,542.16,458.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M589.33,458.97c-1.93,0-3.5-1.57-3.5-3.5v-22.54c0-2-1.63-3.64-3.64-3.64h-14.76 c-5.87,0-10.64-4.77-10.64-10.64v-76.57c0-1.93,1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5v76.57c0,2,1.63,3.64,3.64,3.64h14.76 c5.87,0,10.64,4.77,10.64,10.64v22.54C592.83,457.4,591.26,458.97,589.33,458.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M673.94,458.97c-1.93,0-3.5-1.57-3.5-3.5v-24.59c0-5.8,4.72-10.52,10.52-10.52h65.85 c1.94,0,3.52-1.58,3.52-3.52v-74.75c0-1.93,1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5v74.75c0,5.8-4.72,10.52-10.52,10.52h-65.85 c-1.94,0-3.52,1.58-3.52,3.52v24.59C677.44,457.4,675.88,458.97,673.94,458.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M626.78,458.97c-1.93,0-3.5-1.57-3.5-3.5v-22.54c0-5.87,4.77-10.64,10.64-10.64h14.76 c2.01,0,3.64-1.63,3.64-3.64v-76.57c0-1.93,1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5v76.57c0,5.87-4.77,10.64-10.64,10.64h-14.76 c-2.01,0-3.64,1.63-3.64,3.64v22.54C630.28,457.4,628.71,458.97,626.78,458.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130630768218939033370000009400595862598657471_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.3938,
    y1: 763.5912,
    x2: 466.3451,
    y2: 660.7425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130630768218939033370000009400595862598657471_)"
    },
    d: "M458.08,669.83l-14.15,3.54l3.54,26.53 c0,0-5.31,5.31-7.08,12.38c-1.77,7.08-3.4,36.78-3.4,36.78l-3.36,2.03l-0.41,1.69l9.77,13.14l-1.62-10.45 c-0.26-1.66,0.19-5.03,0.05-5.1c5.31-14.15,16.66-54.01,16.66-54.01V669.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075877303137274838120000009198126931839196340_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.7868,
    y1: 1094.4106,
    x2: 557.8315,
    y2: -448.8635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075877303137274838120000009198126931839196340_)"
    },
    d: "M462.22,752.98c-0.15,0-0.3,0.01-0.46,0 c0.68-8.53,3.81-46.08,6.94-60.15c3.54-15.92-5.31-47.76-5.31-47.76l-15.92,15.92l8.84,30.07c-6.06,9.09,0.99,62.33,0.84,62.31 l0.01,0.12l-2.31,3.17l0.28,1.72l14.1,8.32l-5.55-9.01C462.8,756.26,462.32,754.64,462.22,752.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165228896010260059200000012963011406373483420_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.5333,
    y1: 606.9935,
    x2: 447.4676,
    y2: 606.9935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165228896010260059200000012963011406373483420_)"
    },
    d: "M444.31,574.46c0,0-31,43.01,0,65.06 l3.16-2.82c0,0-15.39-18.14,0-40.35L444.31,574.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136412884266182393910000004626779789874351238_",
    gradientUnits: "userSpaceOnUse",
    x1: -2728.281,
    y1: 735.2279,
    x2: -2743.0996,
    y2: 760.3053,
    gradientTransform: "matrix(-1 0 0 1 -2283.9534 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136412884266182393910000004626779789874351238_)"
    },
    d: "M470.16,768.01h-4.5 c-0.84,0-1.64-0.39-2.15-1.05c-1.4-1.82-4.31-5.38-5.7-5.47c-1.87-0.12-1.63,6.52-1.63,6.52h-1.05l-1.33-8.26 c-0.33-2.08,0.7-4.14,2.57-5.11l0,0c0,0,0.43,3.16,2.75,4.56c2.32,1.4,9.43,6.41,9.43,6.41s0.87-0.12,1.83,0.05 C471.8,765.9,471.6,768.01,470.16,768.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144324163889806973360000005445184074284345787_",
    gradientUnits: "userSpaceOnUse",
    x1: -3951.6909,
    y1: -187.7859,
    x2: -3966.5085,
    y2: -162.7099,
    gradientTransform: "matrix(-0.9218 -0.3878 -0.3878 0.9218 -3283.2456 -632.1012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144324163889806973360000005445184074284345787_)"
    },
    d: "M443.34,767.49l-4.15-1.74 c-0.78-0.33-1.36-0.99-1.57-1.81c-0.59-2.22-1.89-6.63-3.13-7.25c-1.68-0.84-4.03,5.38-4.03,5.38l-0.97-0.41l1.98-8.13 c0.5-2.05,2.25-3.54,4.35-3.72l0,0c0,0-0.83,3.08,0.76,5.27c1.59,2.19,6.21,9.56,6.21,9.56s0.85,0.22,1.67,0.75 C445.67,766.19,444.67,768.05,443.34,767.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108288423368906639530000017645460801390574514_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.2881,
    y1: 606.1098,
    x2: 437.8138,
    y2: 696.1123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108288423368906639530000017645460801390574514_)"
    },
    d: "M467.44,618.15 c0,0-0.52,3.19,0.24,11.95c0.76,8.77,4.41,29.35,3.66,49.04c0,0-10.36,2.41-28.35,1.27c0,0-7.59-30.74-5.74-42.43 c1.85-11.69,11.89-20.07,11.89-20.07L467.44,618.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000912039819571239290000015160406552447590315_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.0274,
    y1: 563.1008,
    x2: 461.0547,
    y2: 563.1008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000912039819571239290000015160406552447590315_)"
    },
    points: "459.79,559.58 461.05,574.46  449.03,574.46 452.02,551.74  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006710269988661278820000005141216985664907697_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.6965,
    y1: 576.1318,
    x2: 407.0073,
    y2: 657.8382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006710269988661278820000005141216985664907697_)"
    },
    d: "M445.46,572.4 c4.15-0.23,13.43-0.65,20.01-0.29c3.46,0.19,6.36,2.67,7.07,6.07l1.6,7.68c0.6,2.86,0.51,5.83-0.26,8.65l-6.44,23.64 c0,0-5.73,3.44-18.31-0.24c0,0-11.04-26.34-6.52-43.19C442.96,573.41,444.11,572.48,445.46,572.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102532115197398875120000008273413443138724762_",
    gradientUnits: "userSpaceOnUse",
    x1: 519.5932,
    y1: 569.9578,
    x2: 415.5718,
    y2: 629.5497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102532115197398875120000008273413443138724762_)"
    },
    d: "M472.23,576.8 c1.77,4.67,3.37,9.56,5.09,14.14c0.87,2.29,1.76,4.54,2.71,6.61c0.48,1.03,1.01,1.97,1.49,2.83c0.48,0.85,1.03,1.55,1.31,1.88 c0.06,0.05-0.13,0.08-0.19,0.09c-0.04,0,1.2,0.2,1.58,0.27l1.48-0.01c2.12-0.11,4.53-0.48,6.94-0.95 c4.86-0.91,9.92-2.18,15.11-3.14l0.04-0.01c0.99-0.18,1.95,0.47,2.13,1.46c0.12,0.66-0.13,1.3-0.59,1.71 c-2.09,1.84-4.31,3.36-6.61,4.83c-1.16,0.71-2.34,1.4-3.54,2.07c-1.22,0.62-2.45,1.25-3.72,1.83c-2.56,1.12-5.21,2.14-8.26,2.81 c-0.8,0.13-1.59,0.27-2.42,0.39c-0.92,0.03-1.76,0.11-2.77,0.06c-0.54-0.05-1.08-0.12-1.61-0.2c-0.29-0.05-0.5-0.06-0.84-0.15 c-0.37-0.11-0.74-0.23-1.1-0.37c-0.76-0.27-1.25-0.6-1.86-0.94c-0.51-0.34-0.98-0.69-1.43-1.05c-1.67-1.42-2.7-2.83-3.61-4.18 c-0.91-1.35-1.63-2.71-2.28-4.03c-1.3-2.65-2.31-5.28-3.13-7.92c-1.67-5.3-2.8-10.51-3.27-16.04c-0.23-2.65,1.74-4.98,4.39-5.21 c2.19-0.19,4.17,1.12,4.92,3.08L472.23,576.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165955007842946194080000000962097177089629056_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.9288,
    y1: 587.9996,
    x2: 425.9079,
    y2: 647.5912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165955007842946194080000000962097177089629056_)"
    },
    d: "M506.11,600.89l2.15-5.09l11.3-2.81 c0,0,0.9,1.96-3.84,2.81c0,0,1.69,1.87,0.79,4.08C515.59,602.07,505.99,604.28,506.11,600.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172416129750017084210000011775400178366666685_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.0596,
    y1: 563.096,
    x2: 445.6874,
    y2: 528.9197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172416129750017084210000011775400178366666685_)"
    },
    d: "M464.88,542.38 c0.43,0.25,3.81,12.19,0.98,17.19c-2.84,5-11.49-0.6-13.84-7.84C449.67,544.5,453.44,535.64,464.88,542.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109012891535430894810000016927445962823106976_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.4569,
    y1: 572.504,
    x2: 468.6097,
    y2: 572.504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109012891535430894810000016927445962823106976_)"
    },
    d: "M442.44,551.74 c-1.94,9.52-8.38,6.91-12.94,11.15c-7.39,6.86-17.95-0.21-28.23,6.29c-7.42,4.69-10.99,16.7-7.43,26.4 c4.93,13.43,21.78,18.95,30.51,14.86c8.34-3.91,7.16-15.62,18.38-20.14c4.77-1.92,7.12-0.67,9.97-3.52 c5-4.98,3.65-14.66,3.13-18.38c-1.13-8.08-3.84-9.55-2.54-13.1c2.52-6.91,14.27-5.49,15.25-10.36 c0.89-4.44-7.63-12.86-15.64-11.54C440.5,535.44,443.3,547.5,442.44,551.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M397.55,593.3c-0.15,0-0.28-0.1-0.32-0.25c-1.59-6.59-0.87-12,2.14-16.07 c5-6.76,14.7-7.43,14.8-7.43c0.15-0.03,0.33,0.12,0.34,0.3c0.01,0.18-0.12,0.33-0.3,0.34c-0.09,0.01-9.51,0.66-14.32,7.17 c-2.89,3.91-3.57,9.13-2.03,15.53c0.04,0.17-0.07,0.35-0.24,0.39C397.6,593.3,397.57,593.3,397.55,593.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M429.35,599.34c-0.01,0-0.03,0-0.04-0.01c-0.09-0.02-0.14-0.11-0.12-0.2 c1.55-5.94,4.26-10.06,8.07-12.25c2.77-1.6,5.36-1.75,7.65-1.88c2.21-0.13,4.11-0.24,5.64-1.6c3.17-2.82,2.99-9.59-0.55-20.14 c-0.03-0.09,0.02-0.18,0.1-0.21c0.09-0.03,0.18,0.02,0.21,0.1c3.58,10.68,3.73,17.57,0.45,20.48c-1.62,1.44-3.57,1.55-5.84,1.68 c-2.25,0.13-4.8,0.28-7.5,1.83c-3.73,2.15-6.39,6.2-7.91,12.05C429.48,599.29,429.42,599.34,429.35,599.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M447.03,549.38c-0.02,0-0.03,0-0.05-0.01c-0.08-0.03-0.13-0.12-0.1-0.21 c1.23-3.66,4.77-3.11,8.53-2.54c2.38,0.37,4.83,0.74,6.92,0.12c1.55-0.46,2.48-1.18,2.74-2.12c0.46-1.61-1.14-3.41-1.16-3.43 c-0.06-0.07-0.05-0.17,0.01-0.23c0.07-0.06,0.17-0.05,0.23,0.01c0.07,0.08,1.73,1.95,1.23,3.74c-0.3,1.06-1.3,1.85-2.97,2.35 c-2.15,0.64-4.65,0.26-7.06-0.11c-3.77-0.58-7.03-1.08-8.17,2.32C447.17,549.34,447.1,549.38,447.03,549.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049220495383095645600000009943924991270188183_",
    gradientUnits: "userSpaceOnUse",
    x1: -954.7605,
    y1: 995.9839,
    x2: -956.843,
    y2: 1069.2877,
    gradientTransform: "matrix(-0.7574 -0.6529 0.6529 -0.7574 -833.5488 595.4041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000049220495383095645600000009943924991270188183_)"
    },
    cx: 542.03,
    cy: 462.04,
    r: 10.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057141986018757085460000017083248460513625500_",
    gradientUnits: "userSpaceOnUse",
    x1: -989.9686,
    y1: 994.9835,
    x2: -992.0511,
    y2: 1068.2876,
    gradientTransform: "matrix(-0.7574 -0.6529 0.6529 -0.7574 -833.5488 595.4041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000057141986018757085460000017083248460513625500_)"
    },
    cx: 589.71,
    cy: 462.04,
    r: 10.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153694896201608020940000005662602896387107501_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.9687,
    y1: 473.3129,
    x2: 672.9449,
    y2: 410.4236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000153694896201608020940000005662602896387107501_)"
    },
    cx: 627.82,
    cy: 462.04,
    r: 10.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041974498465796456130000012916591052741264047_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.7811,
    y1: 443.3121,
    x2: 668.4515,
    y2: 510.7829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041974498465796456130000012916591052741264047_)"
    },
    d: "M666.32,455.02 c3.88-4.5,10.67-5,15.17-1.12c4.5,3.88,5,10.67,1.12,15.17c-3.88,4.5-10.67,5-15.17,1.12 C662.95,466.31,662.45,459.52,666.32,455.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125598063028079045330000003075598100114867851_",
    gradientUnits: "userSpaceOnUse",
    x1: 2400.9009,
    y1: 550.9167,
    x2: 2038.2441,
    y2: 963.8423,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125598063028079045330000003075598100114867851_)"
    },
    d: "M885.73,761.03 c1.26,0,2.29-1,2.29-2.24v-268.2c0-1.24-1.02-2.24-2.29-2.24c-1.26,0-2.29,1-2.29,2.24v268.2 C883.45,760.02,884.47,761.03,885.73,761.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000916973984507100880000010458147515159145375_",
    gradientUnits: "userSpaceOnUse",
    x1: 2365.4504,
    y1: 520.7633,
    x2: 2002.7938,
    y2: 933.6888,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000916973984507100880000010458147515159145375_)"
    },
    d: "M947.66,761.03 c1.26,0,2.29-1,2.29-2.24v-268.2c0-1.24-1.02-2.24-2.29-2.24c-1.26,0-2.29,1-2.29,2.24v268.2 C945.38,760.02,946.4,761.03,947.66,761.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056428144593789991560000008986822604208408729_",
    gradientUnits: "userSpaceOnUse",
    x1: 2119.7361,
    y1: 623.8317,
    x2: 2241.1765,
    y2: 623.8317,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056428144593789991560000008986822604208408729_)"
    },
    d: "M1099.83,761.03 c0.3,0,0.6-0.06,0.89-0.18c1.16-0.48,1.7-1.8,1.21-2.94L985.06,488c-0.49-1.14-1.84-1.67-3-1.19c-1.16,0.48-1.7,1.8-1.21,2.94 l116.87,269.9C1098.09,760.51,1098.94,761.03,1099.83,761.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160902848149552830700000008277460525368867257_",
    gradientUnits: "userSpaceOnUse",
    x1: 2191.9246,
    y1: 623.8317,
    x2: 2313.3652,
    y2: 623.8317,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160902848149552830700000008277460525368867257_)"
    },
    d: "M1027.64,761.03 c0.3,0,0.6-0.06,0.89-0.18c1.16-0.48,1.7-1.8,1.21-2.94L912.87,488c-0.49-1.14-1.84-1.67-3-1.19c-1.16,0.48-1.7,1.8-1.21,2.94 l116.87,269.9C1025.9,760.51,1026.75,761.03,1027.64,761.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075861315251518229820000008708087500701002400_",
    gradientUnits: "userSpaceOnUse",
    x1: 2229.3877,
    y1: 488.188,
    x2: 2342.8845,
    y2: 488.188,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075861315251518229820000008708087500701002400_)"
    },
    d: "M882.18,491.35h107.05 c1.78,0,3.22-1.42,3.22-3.16l0,0c0-1.75-1.44-3.16-3.22-3.16H882.18c-1.78,0-3.22,1.42-3.22,3.16l0,0 C878.96,489.93,880.4,491.35,882.18,491.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054252254746229712700000009524897405549201081_",
    gradientUnits: "userSpaceOnUse",
    x1: 2218.7356,
    y1: 530.1517,
    x2: 2295.7087,
    y2: 530.1517,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054252254746229712700000009524897405549201081_)"
    },
    d: "M928.42,532.4h72.4 c1.26,0,2.29-1,2.29-2.24s-1.02-2.24-2.29-2.24h-72.4c-1.26,0-2.29,1-2.29,2.24S927.16,532.4,928.42,532.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119117927652837159360000002838391496143087232_",
    gradientUnits: "userSpaceOnUse",
    x1: 2198.8054,
    y1: 581.1965,
    x2: 2271.2078,
    y2: 581.1965,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 950.64,
    y: 578.95,
    style: {
      fill: "url(#SVGID_00000119117927652837159360000002838391496143087232_)"
    },
    width: 72.4,
    height: 4.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102513671526393538540000009965123514558835612_",
    gradientUnits: "userSpaceOnUse",
    x1: 2177.2986,
    y1: 632.2411,
    x2: 2249.7012,
    y2: 632.2411,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 972.15,
    y: 630,
    style: {
      fill: "url(#SVGID_00000102513671526393538540000009965123514558835612_)"
    },
    width: 72.4,
    height: 4.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973791015716798620000017450121369266691991_",
    gradientUnits: "userSpaceOnUse",
    x1: 2152.4595,
    y1: 683.2859,
    x2: 2229.4326,
    y2: 683.2859,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121973791015716798620000017450121369266691991_)"
    },
    d: "M994.7,685.53h72.4 c1.26,0,2.29-1,2.29-2.24c0-1.24-1.02-2.24-2.29-2.24h-72.4c-1.26,0-2.29,1-2.29,2.24C992.41,684.53,993.44,685.53,994.7,685.53 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127737745837743751020000007706615655576775311_",
    gradientUnits: "userSpaceOnUse",
    x1: 2130.6543,
    y1: 734.3315,
    x2: 2207.6274,
    y2: 734.3315,
    gradientTransform: "matrix(-1 0 0 1 3221.8467 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127737745837743751020000007706615655576775311_)"
    },
    d: "M1016.51,736.58h72.4 c1.26,0,2.29-1,2.29-2.24c0-1.24-1.02-2.24-2.29-2.24h-72.4c-1.26,0-2.29,1-2.29,2.24 C1014.22,735.57,1015.24,736.58,1016.51,736.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147930050836832399270000013064001167751576462_",
    gradientUnits: "userSpaceOnUse",
    x1: -3875.9268,
    y1: 483.5111,
    x2: -3849.4507,
    y2: 483.5111,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147930050836832399270000013064001167751576462_)"
    },
    d: "M899.54,482.23 c4.54,0.39,12.41,1.03,18.61,1.3c3.73,0.16,5.88-0.2,7.12-0.7c0,0.14-0.01,0.27-0.01,0.39c-0.03,0.65-0.56,1.18-1.22,1.21 c-11.73,0.65-21.05,0.23-24.37,0.02c-0.69-0.04-1.1-0.79-0.74-1.37C899.1,482.8,899.31,482.51,899.54,482.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160906741897106653780000016436199662549063844_",
    gradientUnits: "userSpaceOnUse",
    x1: -3875.9282,
    y1: 478.3221,
    x2: -3850.1982,
    y2: 478.3221,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160906741897106653780000016436199662549063844_)"
    },
    d: "M918.16,483.53 c-6.21-0.27-14.08-0.91-18.61-1.3c4.46-5.47,18.61-9.16,18.61-9.16h4c2.75,3.96,3.15,7.74,3.12,9.76 C924.04,483.33,921.89,483.7,918.16,483.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008840168469527972650000013901300895451210897_",
    gradientUnits: "userSpaceOnUse",
    x1: -3873.4824,
    y1: 471.0777,
    x2: -3866.0247,
    y2: 471.0777,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008840168469527972650000013901300895451210897_)"
    },
    d: "M922.83,466.55l-0.37,7.4 c-0.04,0.8-0.64,1.48-1.44,1.59c-0.8,0.11-1.87,0.13-3-0.25c-0.7-0.23-1.22-0.82-1.34-1.54l-1.29-7.21H922.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136406599948184082430000007670831158569073807_",
    gradientUnits: "userSpaceOnUse",
    x1: -3928.7087,
    y1: 482.9402,
    x2: -3918.5627,
    y2: 482.9402,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136406599948184082430000007670831158569073807_)"
    },
    d: "M974.75,483.48 c1.97-0.27,2.86-1.3,3.23-2.39c0,0.01,0,0.02,0.01,0.03c0.29,1.15-0.38,2.35-1.72,2.91c-1.62,0.69-3.39,0.8-4.77,0.75 c-1.48-0.06-2.83-0.67-3.58-1.65l-0.01-0.01C969.39,483.85,971.47,483.93,974.75,483.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028305363729968843970000000232059101075005108_",
    gradientUnits: "userSpaceOnUse",
    x1: -3928.635,
    y1: 475.128,
    x2: -3913.7427,
    y2: 475.128,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028305363729968843970000000232059101075005108_)"
    },
    d: "M965.48,466.5h3.3 c5.02-0.1,8.17,10.49,9.21,14.59c-0.37,1.09-1.26,2.11-3.23,2.39c-3.28,0.46-5.36,0.37-6.84-0.36 c-2.71-3.57-4.06-8.8-4.7-11.85C962.47,467.79,965.48,466.5,965.48,466.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136398343413834298440000004792082008355525795_",
    gradientUnits: "userSpaceOnUse",
    x1: -3920.8943,
    y1: 464.8606,
    x2: -3911.9814,
    y2: 464.8606,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136398343413834298440000004792082008355525795_)"
    },
    d: "M968.35,459.63l1.83,7.28 c0.22,0.89-0.2,1.82-1.03,2.24c-1.02,0.53-2.47,1.08-3.79,0.92c-0.62-0.08-1.14-0.51-1.35-1.1l-2.69-7.66L968.35,459.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046324938680350248270000012081382553368885897_",
    gradientUnits: "userSpaceOnUse",
    x1: -3941.5396,
    y1: 490.9246,
    x2: -3824.4563,
    y2: 358.4579,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046324938680350248270000012081382553368885897_)"
    },
    d: "M970.53,461.73 c-2.28,2.02-9.69,2.29-9.69,2.29c-26.69-64.05-37.6-73.15-37.6-73.15c3.85,24.17,0.62,77.69,0.62,77.69 c-4.4,1.94-10.08,0-10.08,0c-0.36-39.58-6.44-74.09-13.63-101.3c18.04-0.41,27.63-6.58,30.76-9.05 C945.95,382.45,970.53,461.73,970.53,461.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071559926951531997340000005209276220554481029_",
    gradientUnits: "userSpaceOnUse",
    x1: -3808.8091,
    y1: 278.8058,
    x2: -4013.1311,
    y2: 456.5142,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071559926951531997340000005209276220554481029_)"
    },
    d: "M926.34,284.56 c3.41,17.03,2.19,47.51,1.39,61.41c-0.23,3.91,2.5,9.32,4.71,13.02c0.35,0.58,0.13,1.32-0.47,1.63 c-3.69,1.9-16.2,7.78-30.69,8.51c-0.97,0.05-1.83-0.61-2.08-1.54c-10.75-40.14-23.24-65.79-23.24-65.79 C889.75,279.77,926.34,284.56,926.34,284.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163790426834261051160000009070234749342861705_",
    gradientUnits: "userSpaceOnUse",
    x1: -3890.8594,
    y1: 431.8539,
    x2: -3886.5886,
    y2: 423.3123,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163790426834261051160000009070234749342861705_)"
    },
    d: "M921.43,389.36 c0.15,0,0.31-0.04,0.44-0.13c0.4-0.25,0.53-0.77,0.29-1.17c-0.14-0.24-3.6-5.82-10.58-9.19c-0.42-0.2-0.94-0.03-1.14,0.4 c-0.2,0.42-0.03,0.94,0.4,1.14c6.51,3.14,9.83,8.48,9.86,8.54C920.86,389.21,921.14,389.36,921.43,389.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183244935056660173620000007257507892092057018_",
    gradientUnits: "userSpaceOnUse",
    x1: -3880.0608,
    y1: 334.9455,
    x2: -3911.7888,
    y2: 363.0412,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183244935056660173620000007257507892092057018_)"
    },
    d: "M947.75,333.43 c-1.1,7.93-4.34,16.59-10.82,25.78l-2.46-2.01c0,0,2.84-11.54,1.23-24.63C939.7,331.78,944.42,332.58,947.75,333.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000200721133896046680000002195089776344136092_",
    gradientUnits: "userSpaceOnUse",
    x1: -3825.843,
    y1: 259.9736,
    x2: -4029.2437,
    y2: 436.8806,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000200721133896046680000002195089776344136092_)"
    },
    d: "M922.53,305.57l3.81-21.01 c0,0,25.48,19.47,21.41,48.87c-3.33-0.84-8.06-1.65-12.05-0.87C934.53,323.13,931.06,312.88,922.53,305.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163040248454861930860000005216434465645387958_",
    gradientUnits: "userSpaceOnUse",
    x1: -4156.4331,
    y1: -1452.6755,
    x2: -4368.9424,
    y2: -1267.8464,
    gradientTransform: "matrix(-0.8771 -0.4804 -0.4804 0.8771 -3491.0398 -446.4186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163040248454861930860000005216434465645387958_)"
    },
    d: "M878.78,297.67l8.88,21.66 c-7.54,10.45-26.65,13.64-34.16,11.94c2.39-5.33,3.36-10.17,3.73-13.68C870.22,313.57,878.78,297.67,878.78,297.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075869777777982535600000004518059730478798223_",
    gradientUnits: "userSpaceOnUse",
    x1: -3768.8196,
    y1: 287.9169,
    x2: -3808.928,
    y2: 333.3731,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075869777777982535600000004518059730478798223_)"
    },
    d: "M857.22,317.59 c-0.37,3.51-1.33,8.35-3.73,13.68c-21.01-2.77-20.66-17.23-20.66-17.23l2.46-1.23C842.11,317.54,851.7,319.3,857.22,317.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013166262991662519020000014509541606711037060_",
    gradientUnits: "userSpaceOnUse",
    x1: -3844.8711,
    y1: 270.8285,
    x2: -3845.144,
    y2: 317.4901,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013166262991662519020000014509541606711037060_)"
    },
    d: "M885.02,275.64l4.75,17.45 c0.53,1.96,2.65,3.01,4.54,2.26c2.04-0.81,4.62-1.92,6.84-3.13c2.37-1.28,3.12-4.33,1.61-6.58l-9.87-14.72L885.02,275.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012438643144562331540000003169878777959661745_",
    gradientUnits: "userSpaceOnUse",
    x1: -4297.8872,
    y1: 462.9373,
    x2: -4320.854,
    y2: 493.3207,
    gradientTransform: "matrix(-0.9217 -0.388 -0.388 0.9217 -2899.6616 -1834.4128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012438643144562331540000003169878777959661745_)"
    },
    d: "M877.98,257.99 c-0.12,0.28-1.2,20.27-1.2,20.27l11.43,0.37l3.84-18.8C892.05,259.83,879.95,253.31,877.98,257.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134221397549759686270000007299957732205404863_",
    gradientUnits: "userSpaceOnUse",
    x1: -4315.4272,
    y1: 470.2666,
    x2: -4287.9932,
    y2: 470.2666,
    gradientTransform: "matrix(-0.9217 -0.388 -0.388 0.9217 -2899.6616 -1834.4128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134221397549759686270000007299957732205404863_)"
    },
    d: "M888.54,263.33l-1.24,10.05 c-0.02,0.13-0.05,0.25-0.1,0.37c-0.31,0.73-1.55,3.18-3.97,1.75c-2.2-1.29-4.23-2.44-5.85-2.37c-0.73,0.03-1.32,0.61-1.35,1.34 c-0.1,1.82-0.24,5.91,0.18,9.49c0.08,0.73,0.72,1.26,1.45,1.24c2.2-0.06,6.84-0.33,10.53-1.41c0.5-0.15,0.88-0.55,0.99-1.06 c0.54-2.48,2.19-10.01,2.98-12.04c0.74-1.9,3.45-2.45,4.61-2.6c0.38-0.05,0.72-0.25,0.94-0.56c0.8-1.09,2.2-3.72-1.04-5.8 c-0.68-0.43-0.86-1.33-0.41-2c0.91-1.32,1.71-3.49-0.71-5.43c-2.46-1.97-4.92-1.03-6.36-0.12c-0.58,0.37-1.33,0.25-1.8-0.25 c-0.27-0.29-0.66-0.46-1.24-0.28c-0.78,0.24-1.6-0.27-1.76-1.08c-0.31-1.54-1.29-3.36-4.13-3.61c-5.05-0.43-7,4.78-6.54,8.26 c0.46,3.47,5.96,3.63,8.98,2.73c2.29-0.69,4.53,1.24,5.48,2.21C888.46,262.48,888.6,262.91,888.54,263.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132088389260766569050000005332496190829842862_",
    gradientUnits: "userSpaceOnUse",
    x1: -4331.5244,
    y1: 486.9987,
    x2: -4313.103,
    y2: 468.099,
    gradientTransform: "matrix(-0.9217 -0.388 -0.388 0.9217 -2899.6616 -1834.4128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132088389260766569050000005332496190829842862_)"
    },
    d: "M891.65,274.36 c0,0-0.54-6.09,1.86-6.92c2.4-0.83,5.24,0.67,3.52,4.53C894.9,276.76,891.65,274.36,891.65,274.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053535078017209932640000015033452924583370892_",
    gradientUnits: "userSpaceOnUse",
    x1: -3867.5312,
    y1: 349.0946,
    x2: -3899.2593,
    y2: 377.1905,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053535078017209932640000015033452924583370892_)"
    },
    d: "M935.49,356.84l-11.5-0.94l-4.98,4.59 c0,0,1.18,1.63,4.86,0.69c3.68-0.94,8.73-1.17,8.73-1.17s5.09,2.29,5.15-2L935.49,356.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009568948646117512960000011499990921886096259_",
    gradientUnits: "userSpaceOnUse",
    x1: -3764.9426,
    y1: 293.1338,
    x2: -3804.0842,
    y2: 337.4944,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009568948646117512960000011499990921886096259_)"
    },
    d: "M833.11,316.11 c0.08,0.78,3.03,0.73,3.27-2.71c-0.53-1.36-2.23-7.45-3.51-8.19c-6.8-3.94-18.25-7.61-18.25-7.61 c-0.79,1.99,0.95,2.84,0.95,2.84l5.83,2.42c-0.18,1.88-0.64,3.61-0.32,5.65c0.24,1.55,1.12,2.93,2.37,3.89 c1.26,0.96,2.94,2.19,4.41,3.08C830.66,317.17,833.11,316.11,833.11,316.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069359027495992720310000006552274404072354216_",
    gradientUnits: "userSpaceOnUse",
    x1: -3782.2661,
    y1: 307.1796,
    x2: -3775.7727,
    y2: 310.0217,
    gradientTransform: "matrix(-1 0 0 1 -2950.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069359027495992720310000006552274404072354216_)"
    },
    d: "M829.76,314.2 c-1.03-1.55-3.96-5.72-5.03-6.47c-0.78-0.54-1.2-1.1-1.29-1.71c-0.07-0.51,0.1-1.01,0.52-1.53l0.21-0.26l5.45,1.63l2.59,2.67 l-0.72,0.7l-2.4-2.49l-4.54-1.36c-0.1,0.18-0.14,0.34-0.12,0.49c0.04,0.31,0.34,0.66,0.87,1.03c1.43,0.99,4.9,6.15,5.29,6.74 L829.76,314.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M702.71,507.54v90.51c0,14.34,11.73,25.92,26.07,25.73l191.83-2.5 c13.22-0.17,24.16-10.34,25.3-23.52l8.1-93.58c1.33-15.32-10.99-28.37-26.36-27.94l-199.92,5.58 C713.8,482.2,702.71,493.61,702.71,507.54z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M736.62,513.35v0.01c0,3.74,3.03,6.77,6.77,6.77l188.83-0.01c3.72,0,6.74-2.99,6.77-6.71l0,0 c0.04-3.77-3.01-6.84-6.77-6.84H743.4C739.66,506.57,736.62,509.61,736.62,513.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M736.62,537.56v0.01c0,3.74,3.03,6.77,6.77,6.77l188.83-0.01c3.72,0,6.74-2.99,6.77-6.71l0,0 c0.04-3.77-3.01-6.84-6.77-6.84H743.4C739.66,530.79,736.62,533.82,736.62,537.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M736.62,561.78v0.01c0,3.74,3.03,6.77,6.77,6.77l188.83-0.01c3.72,0,6.74-2.99,6.77-6.71l0,0 c0.04-3.77-3.01-6.84-6.77-6.84H743.4C739.66,555.01,736.62,558.04,736.62,561.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M736.62,586v0.01c0,3.74,3.03,6.77,6.77,6.77l188.83-0.01c3.72,0,6.74-2.99,6.77-6.71l0,0 c0.04-3.77-3.01-6.84-6.77-6.84H743.4C739.66,579.22,736.62,582.25,736.62,586z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M168.16,270.17v82.71c0,13.11,10.72,23.69,23.82,23.52l175.29-2.29 c12.08-0.16,22.08-9.45,23.12-21.49l7.4-85.52c1.21-14-10.04-25.93-24.09-25.54l-182.69,5.1 C178.29,247.01,168.16,257.43,168.16,270.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.15,275.47v0.01c0,3.42,2.77,6.19,6.19,6.19l172.55-0.01c3.4,0,6.16-2.74,6.19-6.13l0,0 c0.03-3.44-2.75-6.25-6.19-6.25H205.34C201.92,269.28,199.15,272.05,199.15,275.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.15,297.6v0.01c0,3.42,2.77,6.19,6.19,6.19l172.55-0.01c3.4,0,6.16-2.74,6.19-6.13l0,0 c0.03-3.44-2.75-6.25-6.19-6.25H205.34C201.92,291.41,199.15,294.18,199.15,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.15,319.73v0.01c0,3.42,2.77,6.19,6.19,6.19l172.55-0.01c3.4,0,6.16-2.74,6.19-6.13l0,0 c0.03-3.44-2.75-6.25-6.19-6.25H205.34C201.92,313.54,199.15,316.31,199.15,319.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.15,341.86v0.01c0,3.42,2.77,6.19,6.19,6.19l172.55-0.01c3.4,0,6.16-2.74,6.19-6.13l0,0 c0.03-3.44-2.75-6.25-6.19-6.25H205.34C201.92,335.67,199.15,338.44,199.15,341.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.02,387.37c0.94-0.43,1.92-0.77,2.93-1.01c0.28-0.07,0.56,0.11,0.62,0.38 c0.07,0.28-0.11,0.56-0.38,0.62l-0.01,0c-0.94,0.21-1.86,0.52-2.74,0.92c-0.25,0.11-0.55,0-0.66-0.25 C290.66,387.78,290.77,387.49,291.02,387.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.12,386.27c1.01,0.2,2,0.48,2.97,0.83c0.3,0.11,0.45,0.43,0.34,0.73 c-0.11,0.3-0.43,0.45-0.73,0.34l-0.01,0c-0.91-0.34-1.84-0.62-2.79-0.81c-0.3-0.06-0.49-0.35-0.43-0.65 C300.54,386.41,300.83,386.22,301.12,386.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.33,390.61l2.28,2.07c0.25,0.23,0.27,0.62,0.04,0.88c-0.23,0.25-0.62,0.27-0.88,0.04l0,0 l-0.06-0.06l-2.14-1.98l-0.06-0.05c-0.24-0.23-0.26-0.61-0.03-0.85C309.71,390.41,310.09,390.39,310.33,390.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.71,398.59l0.58,1.44c0.21,0.48,0.34,0.97,0.5,1.46c0.12,0.35-0.07,0.73-0.42,0.85 c-0.35,0.12-0.73-0.07-0.85-0.42l0-0.01l-0.02-0.05c-0.15-0.46-0.27-0.94-0.46-1.38l-0.53-1.35l-0.02-0.06 c-0.13-0.34,0.03-0.72,0.37-0.85C316.19,398.09,316.57,398.26,316.71,398.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.84,408.58l-0.13,3.07c-0.02,0.4-0.36,0.71-0.76,0.69c-0.4-0.02-0.71-0.36-0.69-0.76l0-0.01 l0-0.08l0.16-2.92l0-0.08c0.02-0.39,0.36-0.69,0.75-0.67C318.56,407.86,318.86,408.19,318.84,408.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.23,418.65l-1.06,2.87c-0.15,0.4-0.6,0.61-1,0.46c-0.4-0.15-0.61-0.6-0.46-1l0-0.01l0.02-0.06 l1.05-2.74l0.02-0.06c0.15-0.39,0.59-0.59,0.98-0.44C317.18,417.82,317.38,418.26,317.23,418.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.84,427.83l-1.76,2.51c-0.26,0.38-0.78,0.47-1.16,0.2c-0.38-0.26-0.47-0.78-0.2-1.16 l0.01-0.01l0.04-0.05l1.71-2.39l0.04-0.05c0.26-0.37,0.77-0.45,1.14-0.19C313.01,426.96,313.09,427.46,312.84,427.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.38,435.68l-2.21,2.09c-0.35,0.34-0.91,0.32-1.25-0.04c-0.34-0.36-0.32-0.91,0.04-1.25 l0.01-0.01l0.03-0.03l2.17-2.01l0.03-0.03c0.35-0.33,0.9-0.3,1.23,0.05C306.74,434.81,306.72,435.35,306.38,435.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.68,442.24l-2.45,1.77c-0.42,0.3-1,0.21-1.31-0.21c-0.3-0.42-0.21-1.01,0.21-1.31l0.01-0.01 l0.02-0.02l2.43-1.72l0.02-0.02c0.42-0.29,0.99-0.19,1.28,0.22C299.18,441.38,299.09,441.95,298.68,442.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.35,447.91l-2.56,1.6c-0.46,0.29-1.07,0.15-1.36-0.32c-0.29-0.46-0.15-1.07,0.32-1.36 l0.01-0.01l0.01-0.01l2.56-1.56l0.01-0.01c0.46-0.28,1.06-0.13,1.34,0.32C290.94,447.03,290.8,447.63,290.35,447.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.8,453.15l-2.57,1.56c-0.49,0.3-1.13,0.14-1.43-0.35c-0.3-0.49-0.14-1.13,0.35-1.43l0.01-0.01 l2.58-1.53c0.49-0.29,1.12-0.13,1.41,0.36C282.44,452.24,282.28,452.86,281.8,453.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.24,458.33l-2.57,1.55c-0.52,0.31-1.19,0.15-1.5-0.37c-0.31-0.52-0.15-1.19,0.37-1.5 l0.01-0.01l2.59-1.53c0.51-0.3,1.17-0.13,1.48,0.38C273.92,457.37,273.75,458.02,273.24,458.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.68,463.5l-2.57,1.56c-0.54,0.33-1.25,0.16-1.58-0.38c-0.33-0.54-0.16-1.25,0.38-1.58 l0.01-0.01l2.59-1.53c0.54-0.32,1.23-0.14,1.55,0.4C265.39,462.49,265.21,463.18,264.68,463.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.15,468.7l-2.56,1.57c-0.56,0.34-1.28,0.17-1.63-0.38c-0.34-0.56-0.17-1.28,0.38-1.63 l0.01-0.01l2.57-1.56c0.55-0.34,1.28-0.16,1.61,0.4C256.87,467.65,256.7,468.37,256.15,468.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M247.65,473.96l-2.54,1.6c-0.57,0.36-1.31,0.19-1.67-0.37c-0.36-0.57-0.19-1.31,0.37-1.67 l0.01-0.01l2.56-1.59c0.56-0.35,1.31-0.18,1.66,0.39C248.39,472.87,248.21,473.61,247.65,473.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M239.23,479.32l-2.51,1.63l-0.01,0c-0.57,0.37-1.34,0.21-1.72-0.36 c-0.37-0.57-0.21-1.34,0.36-1.72l0.01,0l2.53-1.63c0.57-0.37,1.34-0.2,1.7,0.37C239.96,478.19,239.8,478.95,239.23,479.32 L239.23,479.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.9,484.82l-2.48,1.68l-0.01,0c-0.58,0.39-1.37,0.24-1.77-0.34c-0.39-0.58-0.24-1.37,0.34-1.77 l0.01,0l2.5-1.68c0.58-0.39,1.36-0.23,1.75,0.35C231.63,483.65,231.48,484.43,230.9,484.82L230.9,484.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.7,490.49l-2.43,1.74l-0.01,0.01c-0.58,0.42-1.4,0.28-1.81-0.3c-0.42-0.58-0.28-1.4,0.3-1.81 l0.01,0l2.46-1.73c0.58-0.41,1.39-0.27,1.8,0.31C223.42,489.27,223.28,490.07,222.7,490.49L222.7,490.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.65,496.36l-2.38,1.8l-0.01,0.01c-0.59,0.44-1.42,0.33-1.86-0.26 c-0.44-0.59-0.33-1.42,0.26-1.86l0.01,0l2.41-1.8c0.58-0.44,1.41-0.32,1.85,0.27C215.35,495.09,215.23,495.91,214.65,496.36 L214.65,496.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.77,502.45l-2.32,1.88l-0.01,0.01c-0.58,0.47-1.44,0.38-1.91-0.2 c-0.47-0.58-0.38-1.44,0.2-1.91l0.01-0.01l2.36-1.88c0.58-0.47,1.43-0.37,1.9,0.21c0.46,0.58,0.37,1.43-0.2,1.89L206.77,502.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.12,508.82l-2.25,1.96l-0.01,0.01c-0.58,0.5-1.46,0.45-1.96-0.13 c-0.5-0.58-0.45-1.46,0.13-1.96l0.01-0.01l2.28-1.97c0.58-0.5,1.45-0.43,1.95,0.14c0.5,0.58,0.43,1.44-0.14,1.94L199.12,508.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M191.72,515.46l-2.16,2.05l-0.01,0.01c-0.57,0.54-1.47,0.51-2.01-0.05 c-0.54-0.57-0.51-1.47,0.05-2.01l0.01-0.01l2.2-2.06c0.57-0.53,1.46-0.5,1.99,0.07c0.53,0.57,0.5,1.45-0.06,1.99L191.72,515.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M184.61,522.4l-2.07,2.14l-0.01,0.01c-0.56,0.58-1.47,0.59-2.05,0.04 c-0.58-0.56-0.59-1.47-0.03-2.05l0.01-0.01l2.11-2.16c0.56-0.57,1.47-0.58,2.04-0.02c0.57,0.55,0.58,1.46,0.03,2.03L184.61,522.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.83,529.65l-1.96,2.24l-0.01,0.02c-0.54,0.61-1.47,0.67-2.09,0.14 c-0.61-0.54-0.67-1.47-0.14-2.09l0.01-0.01l2.01-2.26c0.54-0.61,1.47-0.66,2.07-0.12c0.6,0.54,0.66,1.46,0.13,2.07L177.83,529.65 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.42,537.23l-1.84,2.34l-0.02,0.02c-0.52,0.65-1.46,0.77-2.12,0.25 c-0.65-0.52-0.77-1.46-0.25-2.12l0.01-0.01l1.89-2.36c0.52-0.65,1.46-0.75,2.11-0.24c0.64,0.51,0.75,1.45,0.24,2.1L171.42,537.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.43,545.13l-1.71,2.44l-0.02,0.02c-0.49,0.7-1.45,0.86-2.14,0.38 c-0.7-0.49-0.86-1.45-0.38-2.14l0.01-0.01l1.75-2.47c0.49-0.69,1.44-0.85,2.13-0.36c0.69,0.49,0.85,1.44,0.37,2.12L165.43,545.13 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.92,553.36l-1.55,2.53l-0.02,0.03c-0.45,0.74-1.42,0.97-2.16,0.52 c-0.74-0.45-0.97-1.42-0.52-2.16l0-0.01l1.6-2.57c0.45-0.73,1.41-0.96,2.15-0.5c0.73,0.45,0.95,1.41,0.51,2.14L159.92,553.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.95,561.91l-1.38,2.62l-0.02,0.03c-0.41,0.78-1.38,1.08-2.16,0.67 c-0.78-0.41-1.08-1.38-0.67-2.16l0-0.01l1.42-2.67c0.41-0.77,1.37-1.07,2.15-0.65c0.77,0.41,1.06,1.37,0.66,2.14L154.95,561.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.56,570.77l-1.2,2.71l-0.01,0.03c-0.36,0.82-1.32,1.19-2.13,0.83s-1.19-1.32-0.83-2.13l0,0 l1.23-2.77c0.36-0.82,1.32-1.18,2.13-0.82c0.82,0.36,1.18,1.32,0.82,2.13L150.56,570.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.82,579.9l-0.98,2.79l-0.01,0.04c-0.3,0.85-1.23,1.29-2.07,1c-0.85-0.3-1.29-1.23-1-2.07l0,0 l1.01-2.87c0.3-0.85,1.23-1.29,2.07-0.99c0.85,0.3,1.29,1.23,0.99,2.07L146.82,579.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.82,589.3l-0.75,2.86l-0.01,0.04c-0.23,0.87-1.13,1.4-2,1.17c-0.87-0.23-1.4-1.13-1.17-2l0,0 l0.78-2.94c0.23-0.87,1.13-1.39,2-1.16c0.87,0.23,1.39,1.13,1.16,2L143.82,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.57,598.91l-0.52,2.91l-0.01,0.04c-0.16,0.9-1.02,1.49-1.91,1.33 c-0.9-0.16-1.49-1.02-1.33-1.91l0,0l0.54-2.99c0.16-0.89,1.02-1.49,1.91-1.33c0.89,0.16,1.49,1.02,1.33,1.91L141.57,598.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M140.12,608.66l-0.27,2.94l0,0.04c-0.09,0.91-0.89,1.58-1.8,1.5c-0.91-0.09-1.58-0.89-1.5-1.8l0,0 l0.29-3.03c0.09-0.91,0.89-1.58,1.8-1.49c0.91,0.09,1.58,0.89,1.49,1.8L140.12,608.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.51,618.5l-0.02,2.95l0,0.05c0,0.92-0.76,1.66-1.68,1.66c-0.92-0.01-1.66-0.76-1.66-1.68v0 l0.02-3.04c0.01-0.92,0.76-1.66,1.68-1.65c0.92,0.01,1.66,0.76,1.65,1.68L139.51,618.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.77,628.34l0.26,2.95l0,0.05c0.08,0.92-0.6,1.74-1.52,1.82c-0.92,0.08-1.74-0.6-1.82-1.52l0,0 l-0.26-3.04c-0.08-0.92,0.6-1.73,1.52-1.81c0.92-0.08,1.73,0.6,1.81,1.52L139.77,628.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M140.96,638.11l0.54,2.9l0.01,0.05c0.17,0.92-0.43,1.8-1.35,1.97s-1.8-0.43-1.97-1.35l0,0l-0.56-3 c-0.17-0.91,0.43-1.79,1.35-1.96c0.91-0.17,1.79,0.43,1.96,1.35L140.96,638.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.11,647.69l0.84,2.82l0.02,0.05c0.27,0.9-0.24,1.84-1.14,2.11c-0.9,0.27-1.84-0.24-2.11-1.14 l0,0l-0.87-2.93c-0.27-0.9,0.25-1.84,1.14-2.1c0.9-0.27,1.84,0.25,2.1,1.14L143.11,647.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.27,656.98l1.14,2.71l0.02,0.05c0.37,0.87-0.04,1.87-0.91,2.24 c-0.87,0.37-1.87-0.04-2.24-0.91l0,0l-1.18-2.82c-0.36-0.87,0.04-1.87,0.91-2.23c0.87-0.36,1.87,0.04,2.23,0.91L146.27,656.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.45,665.83l1.46,2.55l0.03,0.06c0.47,0.82,0.19,1.87-0.63,2.34 c-0.82,0.47-1.87,0.19-2.34-0.63l0,0l-1.52-2.66c-0.47-0.82-0.18-1.87,0.64-2.34c0.82-0.47,1.87-0.18,2.34,0.64L150.45,665.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.68,674.1l1.76,2.35l0.04,0.05c0.57,0.76,0.42,1.84-0.34,2.42c-0.76,0.57-1.84,0.42-2.42-0.34 l0,0l-1.83-2.45c-0.57-0.76-0.41-1.84,0.35-2.41c0.76-0.57,1.84-0.41,2.41,0.35L155.68,674.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.87,681.67l2.03,2.12l0.04,0.04c0.66,0.69,0.64,1.79-0.06,2.45 c-0.69,0.66-1.79,0.64-2.45-0.05l0,0l-2.11-2.22c-0.66-0.69-0.63-1.79,0.06-2.45c0.69-0.66,1.79-0.63,2.45,0.06L161.87,681.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M168.93,688.47l2.27,1.87l0.05,0.04c0.74,0.61,0.85,1.71,0.24,2.46 c-0.61,0.74-1.71,0.85-2.46,0.24l0,0l-2.36-1.95c-0.74-0.61-0.84-1.71-0.23-2.45c0.61-0.74,1.71-0.84,2.45-0.23L168.93,688.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.73,694.37l2.47,1.58l0.05,0.03c0.82,0.52,1.05,1.61,0.53,2.42 c-0.52,0.82-1.61,1.06-2.42,0.53l0,0l-2.58-1.66c-0.81-0.52-1.05-1.61-0.53-2.42c0.52-0.81,1.61-1.05,2.42-0.53L176.73,694.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.19,699.28l2.65,1.26l0.06,0.03c0.88,0.42,1.25,1.47,0.84,2.35 c-0.42,0.88-1.47,1.25-2.35,0.84l0,0l-2.77-1.32c-0.88-0.42-1.25-1.47-0.83-2.35c0.42-0.88,1.47-1.25,2.35-0.83L185.19,699.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.19,703.06l2.79,0.9l0.07,0.02c0.93,0.3,1.45,1.3,1.15,2.23c-0.3,0.93-1.3,1.45-2.23,1.15l0,0 l-2.92-0.95c-0.93-0.3-1.44-1.3-1.14-2.23c0.3-0.93,1.3-1.44,2.23-1.14L194.19,703.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.6,705.58l2.88,0.49l0.08,0.01c0.97,0.17,1.62,1.09,1.46,2.06c-0.17,0.97-1.09,1.62-2.06,1.46 l0,0l-3.03-0.52c-0.97-0.17-1.62-1.09-1.45-2.06c0.17-0.97,1.09-1.62,2.06-1.45L203.6,705.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.26,706.72l2.92,0.05l0.08,0c0.99,0.02,1.78,0.83,1.76,1.82c-0.02,0.99-0.83,1.78-1.83,1.76 l0,0l-3.08-0.06c-0.99-0.02-1.77-0.84-1.75-1.83c0.02-0.99,0.84-1.77,1.83-1.76L213.26,706.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.96,706.35l2.89-0.4l0.08-0.01c0.99-0.14,1.9,0.55,2.04,1.54c0.14,0.99-0.55,1.9-1.54,2.04 l0,0l-3.05,0.42c-0.99,0.14-1.89-0.55-2.03-1.54c-0.14-0.98,0.55-1.89,1.54-2.03L222.96,706.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.5,704.5l2.8-0.83l0.07-0.02c0.96-0.28,1.97,0.27,2.25,1.23c0.28,0.96-0.27,1.97-1.23,2.25 l0,0l-2.95,0.86c-0.96,0.28-1.96-0.27-2.25-1.23c-0.28-0.96,0.27-1.97,1.23-2.25L232.5,704.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.7,701.3l2.67-1.2l0.06-0.03c0.92-0.41,1.99,0,2.4,0.91c0.41,0.91,0,1.99-0.91,2.4l-2.8,1.26 c-0.92,0.41-1.99,0-2.4-0.91c-0.41-0.92,0-1.99,0.91-2.4l0,0L241.7,701.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.43,696.91l2.51-1.52l0.06-0.03c0.85-0.52,1.96-0.25,2.48,0.6c0.52,0.85,0.25,1.96-0.6,2.48 l-2.62,1.6c-0.85,0.52-1.96,0.25-2.48-0.6c-0.52-0.85-0.25-1.96,0.6-2.48l0,0L250.43,696.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M258.58,691.49l2.32-1.8l0.05-0.04c0.78-0.61,1.91-0.47,2.52,0.31c0.61,0.78,0.47,1.91-0.31,2.51 l-2.41,1.88c-0.78,0.61-1.91,0.47-2.52-0.31c-0.61-0.78-0.47-1.91,0.31-2.52l0,0L258.58,691.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M266.08,685.18l2.11-2.05l0.04-0.04c0.71-0.68,1.84-0.67,2.52,0.04c0.68,0.71,0.67,1.83-0.04,2.52 l-2.19,2.13c-0.71,0.69-1.84,0.67-2.52-0.04c-0.69-0.71-0.67-1.84,0.04-2.52l0,0L266.08,685.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.87,678.1l1.9-2.26l0.04-0.04c0.63-0.75,1.75-0.85,2.5-0.22c0.75,0.63,0.85,1.74,0.22,2.49 l-1.96,2.35c-0.63,0.75-1.75,0.85-2.5,0.22c-0.75-0.63-0.85-1.75-0.23-2.5l0,0L272.87,678.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.91,670.36l1.67-2.44l0.03-0.04c0.55-0.8,1.64-1.01,2.45-0.46c0.8,0.55,1.01,1.64,0.46,2.44 l-1.72,2.52c-0.55,0.8-1.65,1.01-2.45,0.46c-0.8-0.55-1.01-1.65-0.46-2.45l0,0L278.91,670.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.22,662.07l1.46-2.57l0.02-0.04c0.48-0.84,1.54-1.14,2.38-0.66c0.84,0.48,1.14,1.54,0.66,2.38 l-1.49,2.65c-0.47,0.84-1.54,1.14-2.39,0.67c-0.84-0.47-1.14-1.54-0.67-2.39l0,0L284.22,662.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.84,653.35l1.25-2.68l0.02-0.03c0.41-0.87,1.44-1.25,2.31-0.84c0.87,0.41,1.25,1.44,0.84,2.31 l-1.28,2.75c-0.41,0.87-1.44,1.25-2.31,0.84c-0.87-0.41-1.25-1.44-0.84-2.31l0,0L288.84,653.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.8,644.31l1.07-2.77l0.01-0.03c0.34-0.89,1.35-1.33,2.23-0.99c0.89,0.34,1.33,1.34,0.99,2.23 l-1.09,2.83c-0.34,0.89-1.34,1.34-2.24,0.99c-0.89-0.34-1.34-1.34-0.99-2.24l0,0L292.8,644.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.17,635l0.91-2.83l0.01-0.03c0.29-0.9,1.26-1.4,2.16-1.11c0.9,0.29,1.4,1.25,1.11,2.15 l-0.92,2.89c-0.29,0.91-1.26,1.41-2.16,1.12c-0.91-0.29-1.41-1.26-1.12-2.16l0,0L296.17,635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.02,625.51l0.76-2.88l0.01-0.02c0.24-0.91,1.17-1.45,2.09-1.21c0.91,0.24,1.45,1.17,1.21,2.08 l-0.77,2.93c-0.24,0.91-1.17,1.46-2.09,1.22c-0.91-0.24-1.46-1.17-1.22-2.09l0,0L299.02,625.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.42,615.87l0.64-2.91l0-0.02c0.2-0.91,1.1-1.49,2.02-1.29c0.91,0.2,1.49,1.1,1.29,2.01 l-0.64,2.95c-0.2,0.92-1.1,1.5-2.02,1.3c-0.92-0.2-1.5-1.1-1.3-2.02l0,0L301.42,615.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.41,606.13l0.54-2.94l0-0.01c0.17-0.91,1.05-1.52,1.96-1.35c0.91,0.17,1.52,1.04,1.35,1.96 l-0.54,2.97c-0.17,0.92-1.04,1.52-1.96,1.36c-0.92-0.17-1.52-1.04-1.36-1.96l0,0L303.41,606.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.13,596.32l0.48-2.95l0-0.01c0.15-0.91,1.01-1.53,1.92-1.38c0.91,0.15,1.53,1,1.38,1.92 l-0.48,2.97c-0.15,0.91-1.01,1.54-1.92,1.39c-0.91-0.15-1.54-1.01-1.39-1.92L305.13,596.32L305.13,596.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.69,586.46l0.46-2.96c0.14-0.91,0.99-1.53,1.89-1.39c0.91,0.14,1.53,0.98,1.39,1.89 l-0.45,2.97c-0.14,0.91-0.99,1.53-1.9,1.4C307.18,588.22,306.56,587.38,306.69,586.46L306.69,586.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.22,576.57l0.47-2.97c0.14-0.9,0.99-1.51,1.89-1.37c0.9,0.14,1.51,0.99,1.37,1.89l0,0 l-0.46,2.96c-0.14,0.9-0.98,1.52-1.88,1.38C308.7,578.33,308.08,577.49,308.22,576.57L308.22,576.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.83,566.68l0.52-2.97c0.16-0.89,1.01-1.49,1.9-1.33c0.89,0.16,1.49,1.01,1.33,1.9l0,0.01 l-0.51,2.95l0,0.01c-0.15,0.89-1,1.49-1.9,1.34C310.28,568.43,309.68,567.58,309.83,566.68L309.83,566.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.65,556.8l0.61-2.96c0.18-0.88,1.04-1.45,1.92-1.27c0.88,0.18,1.45,1.04,1.27,1.92l0,0.01 l-0.59,2.92l0,0.02c-0.18,0.88-1.04,1.45-1.92,1.28C312.05,558.55,311.47,557.69,311.65,556.8L311.65,556.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M313.81,546.97l0.73-2.93c0.22-0.87,1.09-1.39,1.96-1.18c0.87,0.22,1.39,1.09,1.18,1.96l0,0.02 l-0.71,2.89l-0.01,0.02c-0.21,0.87-1.09,1.4-1.96,1.19C314.12,548.72,313.59,547.84,313.81,546.97L313.81,546.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.43,537.23l0.9-2.89c0.26-0.84,1.15-1.31,1.99-1.05c0.84,0.26,1.3,1.15,1.05,1.98l-0.01,0.03 l-0.86,2.84l-0.01,0.03c-0.26,0.85-1.15,1.32-2,1.07c-0.85-0.26-1.32-1.15-1.07-2L316.43,537.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.66,527.66l1.1-2.83c0.31-0.8,1.22-1.2,2.02-0.89c0.8,0.31,1.2,1.21,0.89,2.01l-0.01,0.03 l-1.06,2.77l-0.01,0.03c-0.31,0.81-1.22,1.22-2.02,0.91C319.76,529.39,319.35,528.48,319.66,527.66L319.66,527.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.59,518.33l1.33-2.73c0.37-0.76,1.28-1.07,2.04-0.7c0.75,0.37,1.07,1.27,0.71,2.03l-0.02,0.04 l-1.27,2.67l-0.02,0.04c-0.37,0.77-1.28,1.09-2.05,0.72C323.54,520.02,323.22,519.11,323.59,518.33L323.59,518.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.32,509.36l1.58-2.6c0.43-0.7,1.35-0.93,2.05-0.5c0.7,0.43,0.92,1.34,0.5,2.04l-0.02,0.04 l-1.52,2.54l-0.02,0.04c-0.43,0.71-1.35,0.94-2.06,0.51C328.11,511,327.88,510.08,328.32,509.36L328.32,509.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.88,500.89l1.82-2.43c0.48-0.64,1.4-0.78,2.04-0.29c0.64,0.48,0.77,1.39,0.3,2.03l-0.02,0.03 l-1.76,2.38l-0.02,0.03c-0.48,0.65-1.4,0.79-2.05,0.31C333.53,502.47,333.39,501.55,333.88,500.89L333.88,500.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.21,492.98l2.04-2.25c0.53-0.58,1.43-0.63,2.01-0.1c0.58,0.53,0.63,1.42,0.11,2.01l-0.03,0.03 l-1.97,2.21l-0.03,0.03c-0.53,0.59-1.44,0.64-2.03,0.11C339.73,494.49,339.68,493.58,340.21,492.98L340.21,492.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.24,485.7l2.23-2.06c0.57-0.52,1.45-0.48,1.97,0.08c0.52,0.56,0.49,1.44-0.07,1.96l-0.03,0.03 l-2.17,2.02l-0.03,0.03c-0.57,0.53-1.45,0.5-1.98-0.07C346.64,487.12,346.67,486.23,347.24,485.7L347.24,485.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M354.9,479.08l2.41-1.85c0.6-0.46,1.45-0.35,1.91,0.25c0.46,0.59,0.35,1.44-0.24,1.9l-0.03,0.02 l-2.34,1.82l-0.03,0.02c-0.6,0.46-1.46,0.36-1.92-0.24C354.19,480.41,354.3,479.55,354.9,479.08L354.9,479.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M363.11,473.16l2.56-1.63c0.62-0.39,1.44-0.21,1.83,0.41c0.39,0.62,0.21,1.43-0.4,1.83l-0.03,0.02 l-2.49,1.61l-0.03,0.02c-0.62,0.4-1.45,0.22-1.85-0.4C362.31,474.39,362.48,473.57,363.11,473.16L363.11,473.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.81,468l2.7-1.4c0.63-0.33,1.41-0.08,1.74,0.55c0.33,0.63,0.08,1.41-0.54,1.74l-0.03,0.02 l-2.63,1.38l-0.03,0.02c-0.64,0.34-1.42,0.09-1.76-0.55C370.92,469.12,371.17,468.33,371.81,468L371.81,468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M380.94,463.62l2.81-1.15c0.64-0.26,1.38,0.04,1.64,0.69c0.26,0.64-0.04,1.37-0.68,1.64 l-0.03,0.01l-2.74,1.14l-0.03,0.01c-0.65,0.27-1.39-0.04-1.66-0.68C379.97,464.64,380.28,463.9,380.94,463.62L380.94,463.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.41,460.09l2.9-0.89c0.65-0.2,1.33,0.17,1.53,0.81c0.2,0.64-0.16,1.33-0.8,1.53l-0.03,0.01 l-2.83,0.89l-0.03,0.01c-0.65,0.2-1.35-0.16-1.55-0.81C389.39,460.99,389.75,460.3,390.41,460.09L390.41,460.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M400.17,457.44l2.97-0.61c0.65-0.13,1.28,0.28,1.41,0.93c0.13,0.64-0.28,1.27-0.92,1.41 l-0.03,0.01l-2.9,0.62l-0.03,0.01c-0.65,0.14-1.29-0.28-1.43-0.93C399.09,458.22,399.51,457.58,400.17,457.44L400.17,457.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M410.13,455.73l3.02-0.32c0.64-0.07,1.21,0.39,1.28,1.03c0.07,0.63-0.39,1.2-1.02,1.28l-0.03,0 l-2.95,0.34l-0.03,0c-0.64,0.07-1.22-0.39-1.29-1.03C409.02,456.39,409.48,455.81,410.13,455.73L410.13,455.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.21,455.02l3.03-0.02c0.61,0,1.1,0.49,1.11,1.09c0,0.6-0.48,1.1-1.08,1.11l-0.03,0l-2.97,0.05 l-0.03,0c-0.62,0.01-1.13-0.48-1.14-1.1c-0.01-0.62,0.48-1.13,1.1-1.14C420.2,455.02,420.21,455.02,420.21,455.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M430.31,455.29l3.02,0.27c0.57,0.05,1,0.56,0.94,1.13c-0.05,0.57-0.55,0.99-1.12,0.95l-0.03,0 l-2.96-0.23l-0.03,0c-0.58-0.05-1.02-0.55-0.97-1.14c0.05-0.58,0.55-1.02,1.14-0.97C430.3,455.29,430.31,455.29,430.31,455.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M440.32,456.52l2.98,0.55c0.53,0.1,0.89,0.61,0.79,1.14c-0.1,0.53-0.6,0.88-1.13,0.79l-0.03,0 l-2.93-0.5l-0.03,0c-0.54-0.09-0.91-0.61-0.82-1.15c0.09-0.54,0.61-0.91,1.15-0.82C440.32,456.52,440.32,456.52,440.32,456.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M450.18,458.66l2.91,0.81c0.49,0.14,0.78,0.65,0.64,1.14c-0.14,0.49-0.64,0.77-1.13,0.64 l-0.02-0.01l-2.87-0.77l-0.02-0.01c-0.5-0.13-0.8-0.65-0.67-1.15c0.13-0.5,0.65-0.8,1.15-0.67 C450.17,458.66,450.17,458.66,450.18,458.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M459.8,461.68l2.83,1.07c0.45,0.17,0.67,0.67,0.5,1.11c-0.17,0.44-0.66,0.67-1.1,0.51l-0.02-0.01 l-2.8-1.02l-0.02-0.01c-0.46-0.17-0.69-0.67-0.53-1.13C458.82,461.74,459.33,461.5,459.8,461.68 C459.79,461.67,459.8,461.67,459.8,461.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M469.11,465.53l2.72,1.32c0.4,0.19,0.57,0.67,0.37,1.07c-0.19,0.4-0.67,0.56-1.07,0.38l-0.02-0.01 l-2.7-1.27l-0.02-0.01c-0.41-0.19-0.59-0.68-0.4-1.09S468.69,465.33,469.11,465.53C469.1,465.53,469.1,465.53,469.11,465.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M478.03,470.19l2.59,1.55c0.35,0.21,0.47,0.67,0.26,1.02c-0.21,0.35-0.66,0.47-1.01,0.26 l-0.02-0.01l-2.58-1.5l-0.02-0.01c-0.36-0.21-0.49-0.68-0.28-1.04C477.19,470.1,477.66,469.98,478.03,470.19 C478.03,470.19,478.03,470.19,478.03,470.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M486.51,475.63l2.44,1.78c0.31,0.22,0.37,0.65,0.15,0.96c-0.22,0.3-0.65,0.37-0.95,0.16 l-0.02-0.01l-2.43-1.72l-0.02-0.01c-0.32-0.22-0.39-0.66-0.17-0.98C485.75,475.47,486.19,475.4,486.51,475.63 C486.5,475.62,486.51,475.62,486.51,475.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M494.46,481.8l2.27,1.99c0.26,0.23,0.29,0.62,0.06,0.88c-0.23,0.26-0.62,0.29-0.88,0.06 l-0.01-0.01l-2.27-1.94l-0.01-0.01c-0.27-0.23-0.3-0.64-0.07-0.91C493.77,481.59,494.18,481.56,494.46,481.8 C494.45,481.79,494.46,481.79,494.46,481.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M501.8,488.66l2.07,2.19c0.22,0.23,0.21,0.59-0.02,0.8c-0.23,0.21-0.58,0.21-0.8-0.02l-0.01-0.01 l-2.07-2.14l-0.01-0.01c-0.22-0.23-0.22-0.6,0.01-0.83C501.19,488.42,501.57,488.43,501.8,488.66 C501.79,488.66,501.79,488.66,501.8,488.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M508.45,496.19l1.85,2.38c0.17,0.22,0.13,0.54-0.09,0.71c-0.22,0.17-0.54,0.13-0.71-0.08 l-0.01-0.01l-1.86-2.33l-0.01-0.01c-0.18-0.23-0.14-0.56,0.08-0.74C507.93,495.92,508.26,495.96,508.45,496.19 C508.44,496.19,508.45,496.19,508.45,496.19z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FFFFFF"
    },
    d: "M969.76,169.05c-5.07-24.07-17.69-15.81-38.82-23.21 c-21.12-7.4-14.94-33.82-28.05-41.97c-17.48-10.86-33.53-0.78-44.41,13.48c-18.07,23.69-30.43,4.42-52.03,14.03 c-12.37,5.5-7.1,13.21-23.83,16.31c-11.7,2.17-24.36-2.94-35.88,0.18c-8.54,2.31-14.73,6.36-16.62,14.63 c2.41,1.13,4.91,2.16,7.48,3.09c32.27,11.63,76.3,7.75,108.92,9.46C857.62,175.64,973.35,186.11,969.76,169.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FFFFFF"
    },
    d: "M258.03,447.27c-3.38-16.06-11.8-10.55-25.9-15.49c-14.09-4.94-9.97-22.56-18.72-28 c-11.67-7.25-22.38-0.52-29.63,8.99c-12.06,15.81-20.31,2.95-34.72,9.36c-8.26,3.67-4.73,8.81-15.9,10.88 c-7.8,1.45-16.25-1.96-23.94,0.12c-5.7,1.54-9.83,4.25-11.09,9.77c1.61,0.76,3.27,1.44,4.99,2.06 c21.53,7.76,50.91,5.17,72.68,6.31C183.2,451.67,260.43,458.65,258.03,447.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.858fc0ba1651d855a4ecb7f36aebd269.svg";
export { ForwardRef as ReactComponent };